import { jsx as T, jsxs as ie, Fragment as Hn } from "react/jsx-runtime";
import { TextField as Jn, Button as gr, IconButton as Ze, SelectField as Kn, SelectFieldOption as yr } from "@funcional/react-ui";
import * as Q from "react";
import H, { useState as Xn, useCallback as br, useEffect as Zn } from "react";
import { useTable as Qn, useFilters as ei } from "react-table";
import "jwt-decode";
import "react-oauth2-pkce";
import { c as ti, O as wt } from "./OptionMenu-416a2d83.js";
import { R as ri } from "./ReactTable.component-e46dcaf3.js";
import * as ni from "react-dom";
import { ListItem as le, ListItemText as de, IconButton as pe } from "@material-ui/core";
function Gu({
  column: { filterValue: e, setFilter: r }
}) {
  return /* @__PURE__ */ T(
    Jn,
    {
      fontSize: "small",
      value: e || "",
      onChange: (n) => {
        r(n.target.value || void 0);
      },
      placeholder: "Filtrar"
    }
  );
}
const M = {
  MASTER: "master",
  INDUSTRY: "industry",
  WHOLESALER: "wholesaler",
  WHOLESALER_BRANCH: "wholesaler_branch",
  POINT_OF_SALES: "point_of_sales",
  RETAILER: "retailer",
  SHOP_ASSISTANT: "shop_assistant",
  SHOP_MANAGER: "shop_manager",
  PHARMACEUTICAL: "pharmaceutical",
  BENEFITS_COMPANY: "benefits_company",
  SUPPORT: "support",
  PHARMA_INDUSTRY: "pharma_industry",
  PHARMA_BENEFIT_MANAGER: "pharma_benefit_manager",
  RETAIL_PHARMA_BENEFIT_MANAGER: "retail_pharma_benefit_manager",
  POINT_OF_SALES_BUYER: "point_of_sales_buyer",
  BENEFICIARY_CARD: "beneficiary_card",
  INDUSTRY_EMPLOYEE: "industry_employee",
  PHARMA_COMPANY: "pharma_company",
  SYSTEM_FUNCIONAL_ACESSO_ACCREDITED_ID: "system_funcional_acesso_accredited_id"
};
function Qe(e) {
  const { children: r, roles: n } = e, { user: t } = ti();
  return n !== void 0 && !(t != null && t.hasAnyOfTheseSsoRoles(...n)) ? null : r;
}
function ii(e) {
  if (e.__esModule)
    return e;
  var r = e.default;
  if (typeof r == "function") {
    var n = function t() {
      if (this instanceof t) {
        var i = [null];
        i.push.apply(i, arguments);
        var a = Function.bind.apply(r, i);
        return new a();
      }
      return r.apply(this, arguments);
    };
    n.prototype = r.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(t) {
    var i = Object.getOwnPropertyDescriptor(e, t);
    Object.defineProperty(n, t, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[t];
      }
    });
  }), n;
}
var Ht = {}, ue = {}, ai = {
  get exports() {
    return ue;
  },
  set exports(e) {
    ue = e;
  }
};
(function(e) {
  function r(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(ai);
var ce = {}, oi = {
  get exports() {
    return ce;
  },
  set exports(e) {
    ce = e;
  }
}, Ct = {}, si = {
  get exports() {
    return Ct;
  },
  set exports(e) {
    Ct = e;
  }
};
(function(e) {
  function r(n) {
    "@babel/helpers - typeof";
    return e.exports = r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, r(n);
  }
  e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
})(si);
(function(e) {
  var r = Ct.default;
  function n(i) {
    if (typeof WeakMap != "function")
      return null;
    var a = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (n = function(u) {
      return u ? o : a;
    })(i);
  }
  function t(i, a) {
    if (!a && i && i.__esModule)
      return i;
    if (i === null || r(i) !== "object" && typeof i != "function")
      return {
        default: i
      };
    var o = n(a);
    if (o && o.has(i))
      return o.get(i);
    var s = {}, u = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var c in i)
      if (c !== "default" && Object.prototype.hasOwnProperty.call(i, c)) {
        var f = u ? Object.getOwnPropertyDescriptor(i, c) : null;
        f && (f.get || f.set) ? Object.defineProperty(s, c, f) : s[c] = i[c];
      }
    return s.default = i, o && o.set(i, s), s;
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(oi);
var et = {};
function hn(e, r) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function() {
    return e.apply(void 0, arguments) || r.apply(void 0, arguments);
  };
}
function w() {
  return w = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
    }
    return e;
  }, w.apply(this, arguments);
}
function ye(e) {
  "@babel/helpers - typeof";
  return ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ye(e);
}
function tt(e) {
  return e && ye(e) === "object" && e.constructor === Object;
}
function Ce(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: !0
  }, t = n.clone ? w({}, e) : e;
  return tt(e) && tt(r) && Object.keys(r).forEach(function(i) {
    i !== "__proto__" && (tt(r[i]) && i in e ? t[i] = Ce(e[i], r[i], n) : t[i] = r[i]);
  }), t;
}
var Y = {}, Er = {
  get exports() {
    return Y;
  },
  set exports(e) {
    Y = e;
  }
}, qe = {}, ui = {
  get exports() {
    return qe;
  },
  set exports(e) {
    qe = e;
  }
}, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rr;
function ci() {
  if (Rr)
    return L;
  Rr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
  function x(v) {
    if (typeof v == "object" && v !== null) {
      var U = v.$$typeof;
      switch (U) {
        case r:
          switch (v = v.type, v) {
            case u:
            case c:
            case t:
            case a:
            case i:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case f:
                case g:
                case y:
                case o:
                  return v;
                default:
                  return U;
              }
          }
        case n:
          return U;
      }
    }
  }
  function O(v) {
    return x(v) === c;
  }
  return L.AsyncMode = u, L.ConcurrentMode = c, L.ContextConsumer = s, L.ContextProvider = o, L.Element = r, L.ForwardRef = f, L.Fragment = t, L.Lazy = g, L.Memo = y, L.Portal = n, L.Profiler = a, L.StrictMode = i, L.Suspense = d, L.isAsyncMode = function(v) {
    return O(v) || x(v) === u;
  }, L.isConcurrentMode = O, L.isContextConsumer = function(v) {
    return x(v) === s;
  }, L.isContextProvider = function(v) {
    return x(v) === o;
  }, L.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === r;
  }, L.isForwardRef = function(v) {
    return x(v) === f;
  }, L.isFragment = function(v) {
    return x(v) === t;
  }, L.isLazy = function(v) {
    return x(v) === g;
  }, L.isMemo = function(v) {
    return x(v) === y;
  }, L.isPortal = function(v) {
    return x(v) === n;
  }, L.isProfiler = function(v) {
    return x(v) === a;
  }, L.isStrictMode = function(v) {
    return x(v) === i;
  }, L.isSuspense = function(v) {
    return x(v) === d;
  }, L.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === t || v === c || v === a || v === i || v === d || v === h || typeof v == "object" && v !== null && (v.$$typeof === g || v.$$typeof === y || v.$$typeof === o || v.$$typeof === s || v.$$typeof === f || v.$$typeof === _ || v.$$typeof === b || v.$$typeof === I || v.$$typeof === p);
  }, L.typeOf = x, L;
}
var q = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sr;
function fi() {
  return Sr || (Sr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, t = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, p = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, I = e ? Symbol.for("react.scope") : 60119;
    function x(E) {
      return typeof E == "string" || typeof E == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      E === t || E === c || E === a || E === i || E === d || E === h || typeof E == "object" && E !== null && (E.$$typeof === g || E.$$typeof === y || E.$$typeof === o || E.$$typeof === s || E.$$typeof === f || E.$$typeof === _ || E.$$typeof === b || E.$$typeof === I || E.$$typeof === p);
    }
    function O(E) {
      if (typeof E == "object" && E !== null) {
        var ne = E.$$typeof;
        switch (ne) {
          case r:
            var Se = E.type;
            switch (Se) {
              case u:
              case c:
              case t:
              case a:
              case i:
              case d:
                return Se;
              default:
                var mr = Se && Se.$$typeof;
                switch (mr) {
                  case s:
                  case f:
                  case g:
                  case y:
                  case o:
                    return mr;
                  default:
                    return ne;
                }
            }
          case n:
            return ne;
        }
      }
    }
    var v = u, U = c, te = s, J = o, $ = r, X = f, re = t, Z = g, R = y, ee = n, Re = a, ae = i, se = d, xe = !1;
    function Me(E) {
      return xe || (xe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), m(E) || O(E) === u;
    }
    function m(E) {
      return O(E) === c;
    }
    function P(E) {
      return O(E) === s;
    }
    function D(E) {
      return O(E) === o;
    }
    function j(E) {
      return typeof E == "object" && E !== null && E.$$typeof === r;
    }
    function C(E) {
      return O(E) === f;
    }
    function V(E) {
      return O(E) === t;
    }
    function N(E) {
      return O(E) === g;
    }
    function k(E) {
      return O(E) === y;
    }
    function z(E) {
      return O(E) === n;
    }
    function W(E) {
      return O(E) === a;
    }
    function F(E) {
      return O(E) === i;
    }
    function S(E) {
      return O(E) === d;
    }
    q.AsyncMode = v, q.ConcurrentMode = U, q.ContextConsumer = te, q.ContextProvider = J, q.Element = $, q.ForwardRef = X, q.Fragment = re, q.Lazy = Z, q.Memo = R, q.Portal = ee, q.Profiler = Re, q.StrictMode = ae, q.Suspense = se, q.isAsyncMode = Me, q.isConcurrentMode = m, q.isContextConsumer = P, q.isContextProvider = D, q.isElement = j, q.isForwardRef = C, q.isFragment = V, q.isLazy = N, q.isMemo = k, q.isPortal = z, q.isProfiler = W, q.isStrictMode = F, q.isSuspense = S, q.isValidElementType = x, q.typeOf = O;
  }()), q;
}
var _r;
function Jt() {
  return _r || (_r = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = ci() : e.exports = fi();
  }(ui)), qe;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var rt, Pr;
function li() {
  if (Pr)
    return rt;
  Pr = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function t(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var u = Object.getOwnPropertyNames(o).map(function(f) {
        return o[f];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        c[f] = f;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch (f) {
      return !1;
    }
  }
  return rt = i() ? Object.assign : function(a, o) {
    for (var s, u = t(a), c, f = 1; f < arguments.length; f++) {
      s = Object(arguments[f]);
      for (var d in s)
        r.call(s, d) && (u[d] = s[d]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          n.call(s, c[h]) && (u[c[h]] = s[c[h]]);
      }
    }
    return u;
  }, rt;
}
var nt, xr;
function Kt() {
  if (xr)
    return nt;
  xr = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return nt = e, nt;
}
var it, Or;
function vn() {
  return Or || (Or = 1, it = Function.call.bind(Object.prototype.hasOwnProperty)), it;
}
var at, Tr;
function di() {
  if (Tr)
    return at;
  Tr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = Kt(), n = {}, t = vn();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console != "undefined" && console.error(o);
      try {
        throw new Error(o);
      } catch (s) {
      }
    };
  }
  function i(a, o, s, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in a)
        if (t(a, f)) {
          var d;
          try {
            if (typeof a[f] != "function") {
              var h = Error(
                (u || "React class") + ": " + s + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = a[f](o, f, u, s, null, r);
          } catch (g) {
            d = g;
          }
          if (d && !(d instanceof Error) && e(
            (u || "React class") + ": type specification of " + s + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var y = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (y != null ? y : "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, at = i, at;
}
var ot, wr;
function pi() {
  if (wr)
    return ot;
  wr = 1;
  var e = Jt(), r = li(), n = Kt(), t = vn(), i = di(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var u = "Warning: " + s;
    typeof console != "undefined" && console.error(u);
    try {
      throw new Error(u);
    } catch (c) {
    }
  });
  function o() {
    return null;
  }
  return ot = function(s, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function d(m) {
      var P = m && (c && m[c] || m[f]);
      if (typeof P == "function")
        return P;
    }
    var h = "<<anonymous>>", y = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: I(),
      arrayOf: x,
      element: O(),
      elementType: v(),
      instanceOf: U,
      node: X(),
      objectOf: J,
      oneOf: te,
      oneOfType: $,
      shape: Z,
      exact: R
    };
    function g(m, P) {
      return m === P ? m !== 0 || 1 / m === 1 / P : m !== m && P !== P;
    }
    function p(m, P) {
      this.message = m, this.data = P && typeof P == "object" ? P : {}, this.stack = "";
    }
    p.prototype = Error.prototype;
    function _(m) {
      if (process.env.NODE_ENV !== "production")
        var P = {}, D = 0;
      function j(V, N, k, z, W, F, S) {
        if (z = z || h, F = F || k, S !== n) {
          if (u) {
            var E = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw E.name = "Invariant Violation", E;
          } else if (process.env.NODE_ENV !== "production" && typeof console != "undefined") {
            var ne = z + ":" + k;
            !P[ne] && // Avoid spamming the console because they are often not actionable except for lib authors
            D < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + F + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), P[ne] = !0, D++);
          }
        }
        return N[k] == null ? V ? N[k] === null ? new p("The " + W + " `" + F + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new p("The " + W + " `" + F + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : m(N, k, z, W, F);
      }
      var C = j.bind(null, !1);
      return C.isRequired = j.bind(null, !0), C;
    }
    function b(m) {
      function P(D, j, C, V, N, k) {
        var z = D[j], W = ae(z);
        if (W !== m) {
          var F = se(z);
          return new p(
            "Invalid " + V + " `" + N + "` of type " + ("`" + F + "` supplied to `" + C + "`, expected ") + ("`" + m + "`."),
            { expectedType: m }
          );
        }
        return null;
      }
      return _(P);
    }
    function I() {
      return _(o);
    }
    function x(m) {
      function P(D, j, C, V, N) {
        if (typeof m != "function")
          return new p("Property `" + N + "` of component `" + C + "` has invalid PropType notation inside arrayOf.");
        var k = D[j];
        if (!Array.isArray(k)) {
          var z = ae(k);
          return new p("Invalid " + V + " `" + N + "` of type " + ("`" + z + "` supplied to `" + C + "`, expected an array."));
        }
        for (var W = 0; W < k.length; W++) {
          var F = m(k, W, C, V, N + "[" + W + "]", n);
          if (F instanceof Error)
            return F;
        }
        return null;
      }
      return _(P);
    }
    function O() {
      function m(P, D, j, C, V) {
        var N = P[D];
        if (!s(N)) {
          var k = ae(N);
          return new p("Invalid " + C + " `" + V + "` of type " + ("`" + k + "` supplied to `" + j + "`, expected a single ReactElement."));
        }
        return null;
      }
      return _(m);
    }
    function v() {
      function m(P, D, j, C, V) {
        var N = P[D];
        if (!e.isValidElementType(N)) {
          var k = ae(N);
          return new p("Invalid " + C + " `" + V + "` of type " + ("`" + k + "` supplied to `" + j + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return _(m);
    }
    function U(m) {
      function P(D, j, C, V, N) {
        if (!(D[j] instanceof m)) {
          var k = m.name || h, z = Me(D[j]);
          return new p("Invalid " + V + " `" + N + "` of type " + ("`" + z + "` supplied to `" + C + "`, expected ") + ("instance of `" + k + "`."));
        }
        return null;
      }
      return _(P);
    }
    function te(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function P(D, j, C, V, N) {
        for (var k = D[j], z = 0; z < m.length; z++)
          if (g(k, m[z]))
            return null;
        var W = JSON.stringify(m, function(S, E) {
          var ne = se(E);
          return ne === "symbol" ? String(E) : E;
        });
        return new p("Invalid " + V + " `" + N + "` of value `" + String(k) + "` " + ("supplied to `" + C + "`, expected one of " + W + "."));
      }
      return _(P);
    }
    function J(m) {
      function P(D, j, C, V, N) {
        if (typeof m != "function")
          return new p("Property `" + N + "` of component `" + C + "` has invalid PropType notation inside objectOf.");
        var k = D[j], z = ae(k);
        if (z !== "object")
          return new p("Invalid " + V + " `" + N + "` of type " + ("`" + z + "` supplied to `" + C + "`, expected an object."));
        for (var W in k)
          if (t(k, W)) {
            var F = m(k, W, C, V, N + "." + W, n);
            if (F instanceof Error)
              return F;
          }
        return null;
      }
      return _(P);
    }
    function $(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var P = 0; P < m.length; P++) {
        var D = m[P];
        if (typeof D != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + xe(D) + " at index " + P + "."
          ), o;
      }
      function j(C, V, N, k, z) {
        for (var W = [], F = 0; F < m.length; F++) {
          var S = m[F], E = S(C, V, N, k, z, n);
          if (E == null)
            return null;
          E.data && t(E.data, "expectedType") && W.push(E.data.expectedType);
        }
        var ne = W.length > 0 ? ", expected one of type [" + W.join(", ") + "]" : "";
        return new p("Invalid " + k + " `" + z + "` supplied to " + ("`" + N + "`" + ne + "."));
      }
      return _(j);
    }
    function X() {
      function m(P, D, j, C, V) {
        return ee(P[D]) ? null : new p("Invalid " + C + " `" + V + "` supplied to " + ("`" + j + "`, expected a ReactNode."));
      }
      return _(m);
    }
    function re(m, P, D, j, C) {
      return new p(
        (m || "React class") + ": " + P + " type `" + D + "." + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + C + "`."
      );
    }
    function Z(m) {
      function P(D, j, C, V, N) {
        var k = D[j], z = ae(k);
        if (z !== "object")
          return new p("Invalid " + V + " `" + N + "` of type `" + z + "` " + ("supplied to `" + C + "`, expected `object`."));
        for (var W in m) {
          var F = m[W];
          if (typeof F != "function")
            return re(C, V, N, W, se(F));
          var S = F(k, W, C, V, N + "." + W, n);
          if (S)
            return S;
        }
        return null;
      }
      return _(P);
    }
    function R(m) {
      function P(D, j, C, V, N) {
        var k = D[j], z = ae(k);
        if (z !== "object")
          return new p("Invalid " + V + " `" + N + "` of type `" + z + "` " + ("supplied to `" + C + "`, expected `object`."));
        var W = r({}, D[j], m);
        for (var F in W) {
          var S = m[F];
          if (t(m, F) && typeof S != "function")
            return re(C, V, N, F, se(S));
          if (!S)
            return new p(
              "Invalid " + V + " `" + N + "` key `" + F + "` supplied to `" + C + "`.\nBad object: " + JSON.stringify(D[j], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(m), null, "  ")
            );
          var E = S(k, F, C, V, N + "." + F, n);
          if (E)
            return E;
        }
        return null;
      }
      return _(P);
    }
    function ee(m) {
      switch (typeof m) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !m;
        case "object":
          if (Array.isArray(m))
            return m.every(ee);
          if (m === null || s(m))
            return !0;
          var P = d(m);
          if (P) {
            var D = P.call(m), j;
            if (P !== m.entries) {
              for (; !(j = D.next()).done; )
                if (!ee(j.value))
                  return !1;
            } else
              for (; !(j = D.next()).done; ) {
                var C = j.value;
                if (C && !ee(C[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Re(m, P) {
      return m === "symbol" ? !0 : P ? P["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && P instanceof Symbol : !1;
    }
    function ae(m) {
      var P = typeof m;
      return Array.isArray(m) ? "array" : m instanceof RegExp ? "object" : Re(P, m) ? "symbol" : P;
    }
    function se(m) {
      if (typeof m == "undefined" || m === null)
        return "" + m;
      var P = ae(m);
      if (P === "object") {
        if (m instanceof Date)
          return "date";
        if (m instanceof RegExp)
          return "regexp";
      }
      return P;
    }
    function xe(m) {
      var P = se(m);
      switch (P) {
        case "array":
        case "object":
          return "an " + P;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + P;
        default:
          return P;
      }
    }
    function Me(m) {
      return !m.constructor || !m.constructor.name ? h : m.constructor.name;
    }
    return y.checkPropTypes = i, y.resetWarningCache = i.resetWarningCache, y.PropTypes = y, y;
  }, ot;
}
var st, Cr;
function hi() {
  if (Cr)
    return st;
  Cr = 1;
  var e = Kt();
  function r() {
  }
  function n() {
  }
  return n.resetWarningCache = r, st = function() {
    function t(o, s, u, c, f, d) {
      if (d !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    t.isRequired = t;
    function i() {
      return t;
    }
    var a = {
      array: t,
      bigint: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: i,
      element: t,
      elementType: t,
      instanceOf: i,
      node: t,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, st;
}
if (process.env.NODE_ENV !== "production") {
  var vi = Jt(), mi = !0;
  Er.exports = pi()(vi.isElement, mi);
} else
  Er.exports = hi()();
function gi(e, r) {
  if (ye(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var t = n.call(e, r || "default");
    if (ye(t) !== "object")
      return t;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function mn(e) {
  var r = gi(e, "string");
  return ye(r) === "symbol" ? r : String(r);
}
function ke(e, r, n) {
  return r = mn(r), r in e ? Object.defineProperty(e, r, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = n, e;
}
var yi = "exact-prop: ​";
function bi(e) {
  return process.env.NODE_ENV === "production" ? e : w({}, e, ke({}, yi, function(r) {
    var n = Object.keys(r).filter(function(t) {
      return !e.hasOwnProperty(t);
    });
    return n.length > 0 ? new Error("The following props are not supported: ".concat(n.map(function(t) {
      return "`".concat(t, "`");
    }).join(", "), ". Please remove them.")) : null;
  }));
}
function Ye(e) {
  for (var r = "https://mui.com/production-error/?code=" + e, n = 1; n < arguments.length; n += 1)
    r += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified Material-UI error #" + e + "; visit " + r + " for the full message.";
}
var Be = {}, Ei = {
  get exports() {
    return Be;
  },
  set exports(e) {
    Be = e;
  }
}, B = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Ri() {
  if (Ar)
    return B;
  Ar = 1;
  var e = 60103, r = 60106, n = 60107, t = 60108, i = 60114, a = 60109, o = 60110, s = 60112, u = 60113, c = 60120, f = 60115, d = 60116, h = 60121, y = 60122, g = 60117, p = 60129, _ = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    e = b("react.element"), r = b("react.portal"), n = b("react.fragment"), t = b("react.strict_mode"), i = b("react.profiler"), a = b("react.provider"), o = b("react.context"), s = b("react.forward_ref"), u = b("react.suspense"), c = b("react.suspense_list"), f = b("react.memo"), d = b("react.lazy"), h = b("react.block"), y = b("react.server.block"), g = b("react.fundamental"), p = b("react.debug_trace_mode"), _ = b("react.legacy_hidden");
  }
  function I(R) {
    if (typeof R == "object" && R !== null) {
      var ee = R.$$typeof;
      switch (ee) {
        case e:
          switch (R = R.type, R) {
            case n:
            case i:
            case t:
            case u:
            case c:
              return R;
            default:
              switch (R = R && R.$$typeof, R) {
                case o:
                case s:
                case d:
                case f:
                case a:
                  return R;
                default:
                  return ee;
              }
          }
        case r:
          return ee;
      }
    }
  }
  var x = a, O = e, v = s, U = n, te = d, J = f, $ = r, X = i, re = t, Z = u;
  return B.ContextConsumer = o, B.ContextProvider = x, B.Element = O, B.ForwardRef = v, B.Fragment = U, B.Lazy = te, B.Memo = J, B.Portal = $, B.Profiler = X, B.StrictMode = re, B.Suspense = Z, B.isAsyncMode = function() {
    return !1;
  }, B.isConcurrentMode = function() {
    return !1;
  }, B.isContextConsumer = function(R) {
    return I(R) === o;
  }, B.isContextProvider = function(R) {
    return I(R) === a;
  }, B.isElement = function(R) {
    return typeof R == "object" && R !== null && R.$$typeof === e;
  }, B.isForwardRef = function(R) {
    return I(R) === s;
  }, B.isFragment = function(R) {
    return I(R) === n;
  }, B.isLazy = function(R) {
    return I(R) === d;
  }, B.isMemo = function(R) {
    return I(R) === f;
  }, B.isPortal = function(R) {
    return I(R) === r;
  }, B.isProfiler = function(R) {
    return I(R) === i;
  }, B.isStrictMode = function(R) {
    return I(R) === t;
  }, B.isSuspense = function(R) {
    return I(R) === u;
  }, B.isValidElementType = function(R) {
    return typeof R == "string" || typeof R == "function" || R === n || R === i || R === p || R === t || R === u || R === c || R === _ || typeof R == "object" && R !== null && (R.$$typeof === d || R.$$typeof === f || R.$$typeof === a || R.$$typeof === o || R.$$typeof === s || R.$$typeof === g || R.$$typeof === h || R[0] === y);
  }, B.typeOf = I, B;
}
var G = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Si() {
  return Nr || (Nr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = 60103, r = 60106, n = 60107, t = 60108, i = 60114, a = 60109, o = 60110, s = 60112, u = 60113, c = 60120, f = 60115, d = 60116, h = 60121, y = 60122, g = 60117, p = 60129, _ = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var b = Symbol.for;
      e = b("react.element"), r = b("react.portal"), n = b("react.fragment"), t = b("react.strict_mode"), i = b("react.profiler"), a = b("react.provider"), o = b("react.context"), s = b("react.forward_ref"), u = b("react.suspense"), c = b("react.suspense_list"), f = b("react.memo"), d = b("react.lazy"), h = b("react.block"), y = b("react.server.block"), g = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), p = b("react.debug_trace_mode"), b("react.offscreen"), _ = b("react.legacy_hidden");
    }
    var I = !1;
    function x(S) {
      return !!(typeof S == "string" || typeof S == "function" || S === n || S === i || S === p || S === t || S === u || S === c || S === _ || I || typeof S == "object" && S !== null && (S.$$typeof === d || S.$$typeof === f || S.$$typeof === a || S.$$typeof === o || S.$$typeof === s || S.$$typeof === g || S.$$typeof === h || S[0] === y));
    }
    function O(S) {
      if (typeof S == "object" && S !== null) {
        var E = S.$$typeof;
        switch (E) {
          case e:
            var ne = S.type;
            switch (ne) {
              case n:
              case i:
              case t:
              case u:
              case c:
                return ne;
              default:
                var Se = ne && ne.$$typeof;
                switch (Se) {
                  case o:
                  case s:
                  case d:
                  case f:
                  case a:
                    return Se;
                  default:
                    return E;
                }
            }
          case r:
            return E;
        }
      }
    }
    var v = o, U = a, te = e, J = s, $ = n, X = d, re = f, Z = r, R = i, ee = t, Re = u, ae = !1, se = !1;
    function xe(S) {
      return ae || (ae = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Me(S) {
      return se || (se = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function m(S) {
      return O(S) === o;
    }
    function P(S) {
      return O(S) === a;
    }
    function D(S) {
      return typeof S == "object" && S !== null && S.$$typeof === e;
    }
    function j(S) {
      return O(S) === s;
    }
    function C(S) {
      return O(S) === n;
    }
    function V(S) {
      return O(S) === d;
    }
    function N(S) {
      return O(S) === f;
    }
    function k(S) {
      return O(S) === r;
    }
    function z(S) {
      return O(S) === i;
    }
    function W(S) {
      return O(S) === t;
    }
    function F(S) {
      return O(S) === u;
    }
    G.ContextConsumer = v, G.ContextProvider = U, G.Element = te, G.ForwardRef = J, G.Fragment = $, G.Lazy = X, G.Memo = re, G.Portal = Z, G.Profiler = R, G.StrictMode = ee, G.Suspense = Re, G.isAsyncMode = xe, G.isConcurrentMode = Me, G.isContextConsumer = m, G.isContextProvider = P, G.isElement = D, G.isForwardRef = j, G.isFragment = C, G.isLazy = V, G.isMemo = N, G.isPortal = k, G.isProfiler = z, G.isStrictMode = W, G.isSuspense = F, G.isValidElementType = x, G.typeOf = O;
  }()), G;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Ri() : e.exports = Si();
})(Ei);
var _i = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Pi(e) {
  var r = "".concat(e).match(_i), n = r && r[1];
  return n || "";
}
function gn(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return e.displayName || e.name || Pi(e) || r;
}
function Mr(e, r, n) {
  var t = gn(r);
  return e.displayName || (t !== "" ? "".concat(n, "(").concat(t, ")") : n);
}
function De(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return gn(e, "Component");
    if (ye(e) === "object")
      switch (e.$$typeof) {
        case Be.ForwardRef:
          return Mr(e, e.render, "ForwardRef");
        case Be.Memo:
          return Mr(e, e.type, "memo");
        default:
          return;
      }
  }
}
function At(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: capitalize(string) expects a string argument." : Ye(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function xi() {
  for (var e = arguments.length, r = new Array(e), n = 0; n < e; n++)
    r[n] = arguments[n];
  return r.reduce(function(t, i) {
    return i == null ? t : (process.env.NODE_ENV !== "production" && typeof i != "function" && console.error("Material-UI: Invalid Argument Type, must only provide functions, undefined, or null."), function() {
      for (var o = arguments.length, s = new Array(o), u = 0; u < o; u++)
        s[u] = arguments[u];
      t.apply(this, s), i.apply(this, s);
    });
  }, function() {
  });
}
function yn(e, r) {
  if (e == null)
    return {};
  var n = {}, t = Object.keys(e), i, a;
  for (a = 0; a < t.length; a++)
    i = t[a], !(r.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function fe(e, r) {
  if (e == null)
    return {};
  var n = yn(e, r), t, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      t = a[i], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
  }
  return n;
}
function bn(e) {
  var r, n, t = "";
  if (typeof e == "string" || typeof e == "number")
    t += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (r = 0; r < e.length; r++)
        e[r] && (n = bn(e[r])) && (t && (t += " "), t += n);
    else
      for (r in e)
        e[r] && (t && (t += " "), t += r);
  return t;
}
function Oi() {
  for (var e, r, n = 0, t = ""; n < arguments.length; )
    (e = arguments[n++]) && (r = bn(e)) && (t && (t += " "), t += r);
  return t;
}
var Ti = typeof Symbol == "function" && Symbol.for;
const wi = Ti ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var Ci = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function Ai() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.disableGlobal, n = r === void 0 ? !1 : r, t = e.productionPrefix, i = t === void 0 ? "jss" : t, a = e.seed, o = a === void 0 ? "" : a, s = o === "" ? "" : "".concat(o, "-"), u = 0, c = function() {
    return u += 1, process.env.NODE_ENV !== "production" && u >= 1e10 && console.warn(["Material-UI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), u;
  };
  return function(f, d) {
    var h = d.options.name;
    if (h && h.indexOf("Mui") === 0 && !d.options.link && !n) {
      if (Ci.indexOf(f.key) !== -1)
        return "Mui-".concat(f.key);
      var y = "".concat(s).concat(h, "-").concat(f.key);
      return !d.options.theme[wi] || o !== "" ? y : "".concat(y, "-").concat(c());
    }
    if (process.env.NODE_ENV === "production")
      return "".concat(s).concat(i).concat(c());
    var g = "".concat(f.key, "-").concat(c());
    return d.options.classNamePrefix ? "".concat(s).concat(d.options.classNamePrefix, "-").concat(g) : "".concat(s).concat(g);
  };
}
function Ni(e) {
  var r = e.theme, n = e.name, t = e.props;
  if (!r || !r.props || !r.props[n])
    return t;
  var i = r.props[n], a;
  for (a in i)
    t[a] === void 0 && (t[a] = i[a]);
  return t;
}
var Mi = process.env.NODE_ENV === "production";
function oe(e, r) {
  if (!Mi) {
    if (e)
      return;
    var n = "Warning: " + r;
    typeof console != "undefined" && console.warn(n);
    try {
      throw Error(n);
    } catch (t) {
    }
  }
}
var Ir = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Ue = (typeof window == "undefined" ? "undefined" : Ir(window)) === "object" && (typeof document == "undefined" ? "undefined" : Ir(document)) === "object" && document.nodeType === 9;
function $r(e, r) {
  for (var n = 0; n < r.length; n++) {
    var t = r[n];
    t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(e, mn(t.key), t);
  }
}
function En(e, r, n) {
  return r && $r(e.prototype, r), n && $r(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Nt(e, r) {
  return Nt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, i) {
    return t.__proto__ = i, t;
  }, Nt(e, r);
}
function Rn(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, Nt(e, r);
}
function jr(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var Ii = {}.constructor;
function Mt(e) {
  if (e == null || typeof e != "object")
    return e;
  if (Array.isArray(e))
    return e.map(Mt);
  if (e.constructor !== Ii)
    return e;
  var r = {};
  for (var n in e)
    r[n] = Mt(e[n]);
  return r;
}
function Xt(e, r, n) {
  e === void 0 && (e = "unnamed");
  var t = n.jss, i = Mt(r), a = t.plugins.onCreateRule(e, i, n);
  return a || (e[0] === "@" && process.env.NODE_ENV !== "production" && oe(!1, "[JSS] Unknown rule " + e), null);
}
var kr = function(r, n) {
  for (var t = "", i = 0; i < r.length && r[i] !== "!important"; i++)
    t && (t += n), t += r[i];
  return t;
}, Pe = function(r) {
  if (!Array.isArray(r))
    return r;
  var n = "";
  if (Array.isArray(r[0]))
    for (var t = 0; t < r.length && r[t] !== "!important"; t++)
      n && (n += ", "), n += kr(r[t], " ");
  else
    n = kr(r, ", ");
  return r[r.length - 1] === "!important" && (n += " !important"), n;
};
function Ne(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function Ie(e, r) {
  for (var n = "", t = 0; t < r; t++)
    n += "  ";
  return n + e;
}
function Fe(e, r, n) {
  n === void 0 && (n = {});
  var t = "";
  if (!r)
    return t;
  var i = n, a = i.indent, o = a === void 0 ? 0 : a, s = r.fallbacks;
  n.format === !1 && (o = -1 / 0);
  var u = Ne(n), c = u.linebreak, f = u.space;
  if (e && o++, s)
    if (Array.isArray(s))
      for (var d = 0; d < s.length; d++) {
        var h = s[d];
        for (var y in h) {
          var g = h[y];
          g != null && (t && (t += c), t += Ie(y + ":" + f + Pe(g) + ";", o));
        }
      }
    else
      for (var p in s) {
        var _ = s[p];
        _ != null && (t && (t += c), t += Ie(p + ":" + f + Pe(_) + ";", o));
      }
  for (var b in r) {
    var I = r[b];
    I != null && b !== "fallbacks" && (t && (t += c), t += Ie(b + ":" + f + Pe(I) + ";", o));
  }
  return !t && !n.allowEmpty || !e ? t : (o--, t && (t = "" + c + t + c), Ie("" + e + f + "{" + t, o) + Ie("}", o));
}
var $i = /([[\].#*$><+~=|^:(),"'`\s])/g, Dr = typeof CSS != "undefined" && CSS.escape, Zt = function(e) {
  return Dr ? Dr(e) : e.replace($i, "\\$1");
}, Sn = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "style", this.isProcessed = !1;
    var a = i.sheet, o = i.Renderer;
    this.key = n, this.options = i, this.style = t, a ? this.renderer = a.renderer : o && (this.renderer = new o());
  }
  var r = e.prototype;
  return r.prop = function(t, i, a) {
    if (i === void 0)
      return this.style[t];
    var o = a ? a.force : !1;
    if (!o && this.style[t] === i)
      return this;
    var s = i;
    (!a || a.process !== !1) && (s = this.options.jss.plugins.onChangeValue(i, t, this));
    var u = s == null || s === !1, c = t in this.style;
    if (u && !c && !o)
      return this;
    var f = u && c;
    if (f ? delete this.style[t] : this.style[t] = s, this.renderable && this.renderer)
      return f ? this.renderer.removeProperty(this.renderable, t) : this.renderer.setProperty(this.renderable, t, s), this;
    var d = this.options.sheet;
    return d && d.attached && process.env.NODE_ENV !== "production" && oe(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), It = /* @__PURE__ */ function(e) {
  Rn(r, e);
  function r(t, i, a) {
    var o;
    o = e.call(this, t, i, a) || this;
    var s = a.selector, u = a.scoped, c = a.sheet, f = a.generateId;
    return s ? o.selectorText = s : u !== !1 && (o.id = f(jr(jr(o)), c), o.selectorText = "." + Zt(o.id)), o;
  }
  var n = r.prototype;
  return n.applyTo = function(i) {
    var a = this.renderer;
    if (a) {
      var o = this.toJSON();
      for (var s in o)
        a.setProperty(i, s, o[s]);
    }
    return this;
  }, n.toJSON = function() {
    var i = {};
    for (var a in this.style) {
      var o = this.style[a];
      typeof o != "object" ? i[a] = o : Array.isArray(o) && (i[a] = Pe(o));
    }
    return i;
  }, n.toString = function(i) {
    var a = this.options.sheet, o = a ? a.options.link : !1, s = o ? w({}, i, {
      allowEmpty: !0
    }) : i;
    return Fe(this.selectorText, this.style, s);
  }, En(r, [{
    key: "selector",
    set: function(i) {
      if (i !== this.selectorText) {
        this.selectorText = i;
        var a = this.renderer, o = this.renderable;
        if (!(!o || !a)) {
          var s = a.setSelector(o, i);
          s || a.replaceRule(o, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), r;
}(Sn), ji = {
  onCreateRule: function(r, n, t) {
    return r[0] === "@" || t.parent && t.parent.type === "keyframes" ? null : new It(r, n, t);
  }
}, ut = {
  indent: 1,
  children: !0
}, ki = /@([\w-]+)/, Di = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var a = n.match(ki);
    this.at = a ? a[1] : "unknown", this.query = i.name || "@" + this.at, this.options = i, this.rules = new Ke(w({}, i, {
      parent: this
    }));
    for (var o in t)
      this.rules.add(o, t[o]);
    this.rules.process();
  }
  var r = e.prototype;
  return r.getRule = function(t) {
    return this.rules.get(t);
  }, r.indexOf = function(t) {
    return this.rules.indexOf(t);
  }, r.addRule = function(t, i, a) {
    var o = this.rules.add(t, i, a);
    return o ? (this.options.jss.plugins.onProcessRule(o), o) : null;
  }, r.replaceRule = function(t, i, a) {
    var o = this.rules.replace(t, i, a);
    return o && this.options.jss.plugins.onProcessRule(o), o;
  }, r.toString = function(t) {
    t === void 0 && (t = ut);
    var i = Ne(t), a = i.linebreak;
    if (t.indent == null && (t.indent = ut.indent), t.children == null && (t.children = ut.children), t.children === !1)
      return this.query + " {}";
    var o = this.rules.toString(t);
    return o ? this.query + " {" + a + o + a + "}" : "";
  }, e;
}(), Vi = /@container|@media|@supports\s+/, zi = {
  onCreateRule: function(r, n, t) {
    return Vi.test(r) ? new Di(r, n, t) : null;
  }
}, ct = {
  indent: 1,
  children: !0
}, Fi = /@keyframes\s+([\w-]+)/, $t = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var a = n.match(Fi);
    a && a[1] ? this.name = a[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && oe(!1, "[JSS] Bad keyframes name " + n)), this.key = this.type + "-" + this.name, this.options = i;
    var o = i.scoped, s = i.sheet, u = i.generateId;
    this.id = o === !1 ? this.name : Zt(u(this, s)), this.rules = new Ke(w({}, i, {
      parent: this
    }));
    for (var c in t)
      this.rules.add(c, t[c], w({}, i, {
        parent: this
      }));
    this.rules.process();
  }
  var r = e.prototype;
  return r.toString = function(t) {
    t === void 0 && (t = ct);
    var i = Ne(t), a = i.linebreak;
    if (t.indent == null && (t.indent = ct.indent), t.children == null && (t.children = ct.children), t.children === !1)
      return this.at + " " + this.id + " {}";
    var o = this.rules.toString(t);
    return o && (o = "" + a + o + a), this.at + " " + this.id + " {" + o + "}";
  }, e;
}(), Ui = /@keyframes\s+/, Wi = /\$([\w-]+)/g, jt = function(r, n) {
  return typeof r == "string" ? r.replace(Wi, function(t, i) {
    return i in n ? n[i] : (process.env.NODE_ENV !== "production" && oe(!1, '[JSS] Referenced keyframes rule "' + i + '" is not defined.'), t);
  }) : r;
}, Vr = function(r, n, t) {
  var i = r[n], a = jt(i, t);
  a !== i && (r[n] = a);
}, Li = {
  onCreateRule: function(r, n, t) {
    return typeof r == "string" && Ui.test(r) ? new $t(r, n, t) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(r, n, t) {
    return n.type !== "style" || !t || ("animation-name" in r && Vr(r, "animation-name", t.keyframes), "animation" in r && Vr(r, "animation", t.keyframes)), r;
  },
  onChangeValue: function(r, n, t) {
    var i = t.options.sheet;
    if (!i)
      return r;
    switch (n) {
      case "animation":
        return jt(r, i.keyframes);
      case "animation-name":
        return jt(r, i.keyframes);
      default:
        return r;
    }
  }
}, qi = /* @__PURE__ */ function(e) {
  Rn(r, e);
  function r() {
    return e.apply(this, arguments) || this;
  }
  var n = r.prototype;
  return n.toString = function(i) {
    var a = this.options.sheet, o = a ? a.options.link : !1, s = o ? w({}, i, {
      allowEmpty: !0
    }) : i;
    return Fe(this.key, this.style, s);
  }, r;
}(Sn), Yi = {
  onCreateRule: function(r, n, t) {
    return t.parent && t.parent.type === "keyframes" ? new qi(r, n, t) : null;
  }
}, Bi = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = t, this.options = i;
  }
  var r = e.prototype;
  return r.toString = function(t) {
    var i = Ne(t), a = i.linebreak;
    if (Array.isArray(this.style)) {
      for (var o = "", s = 0; s < this.style.length; s++)
        o += Fe(this.at, this.style[s]), this.style[s + 1] && (o += a);
      return o;
    }
    return Fe(this.at, this.style, t);
  }, e;
}(), Gi = /@font-face/, Hi = {
  onCreateRule: function(r, n, t) {
    return Gi.test(r) ? new Bi(r, n, t) : null;
  }
}, Ji = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = t, this.options = i;
  }
  var r = e.prototype;
  return r.toString = function(t) {
    return Fe(this.key, this.style, t);
  }, e;
}(), Ki = {
  onCreateRule: function(r, n, t) {
    return r === "@viewport" || r === "@-ms-viewport" ? new Ji(r, n, t) : null;
  }
}, Xi = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = t, this.options = i;
  }
  var r = e.prototype;
  return r.toString = function(t) {
    if (Array.isArray(this.value)) {
      for (var i = "", a = 0; a < this.value.length; a++)
        i += this.key + " " + this.value[a] + ";", this.value[a + 1] && (i += `
`);
      return i;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), Zi = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, Qi = {
  onCreateRule: function(r, n, t) {
    return r in Zi ? new Xi(r, n, t) : null;
  }
}, zr = [ji, zi, Li, Yi, Hi, Ki, Qi], ea = {
  process: !0
}, Fr = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Ke = /* @__PURE__ */ function() {
  function e(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var r = e.prototype;
  return r.add = function(t, i, a) {
    var o = this.options, s = o.parent, u = o.sheet, c = o.jss, f = o.Renderer, d = o.generateId, h = o.scoped, y = w({
      classes: this.classes,
      parent: s,
      sheet: u,
      jss: c,
      Renderer: f,
      generateId: d,
      scoped: h,
      name: t,
      keyframes: this.keyframes,
      selector: void 0
    }, a), g = t;
    t in this.raw && (g = t + "-d" + this.counter++), this.raw[g] = i, g in this.classes && (y.selector = "." + Zt(this.classes[g]));
    var p = Xt(g, i, y);
    if (!p)
      return null;
    this.register(p);
    var _ = y.index === void 0 ? this.index.length : y.index;
    return this.index.splice(_, 0, p), p;
  }, r.replace = function(t, i, a) {
    var o = this.get(t), s = this.index.indexOf(o);
    o && this.remove(o);
    var u = a;
    return s !== -1 && (u = w({}, a, {
      index: s
    })), this.add(t, i, u);
  }, r.get = function(t) {
    return this.map[t];
  }, r.remove = function(t) {
    this.unregister(t), delete this.raw[t.key], this.index.splice(this.index.indexOf(t), 1);
  }, r.indexOf = function(t) {
    return this.index.indexOf(t);
  }, r.process = function() {
    var t = this.options.jss.plugins;
    this.index.slice(0).forEach(t.onProcessRule, t);
  }, r.register = function(t) {
    this.map[t.key] = t, t instanceof It ? (this.map[t.selector] = t, t.id && (this.classes[t.key] = t.id)) : t instanceof $t && this.keyframes && (this.keyframes[t.name] = t.id);
  }, r.unregister = function(t) {
    delete this.map[t.key], t instanceof It ? (delete this.map[t.selector], delete this.classes[t.key]) : t instanceof $t && delete this.keyframes[t.name];
  }, r.update = function() {
    var t, i, a;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (t = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], a = arguments.length <= 2 ? void 0 : arguments[2]) : (i = arguments.length <= 0 ? void 0 : arguments[0], a = arguments.length <= 1 ? void 0 : arguments[1], t = null), t)
      this.updateOne(this.get(t), i, a);
    else
      for (var o = 0; o < this.index.length; o++)
        this.updateOne(this.index[o], i, a);
  }, r.updateOne = function(t, i, a) {
    a === void 0 && (a = ea);
    var o = this.options, s = o.jss.plugins, u = o.sheet;
    if (t.rules instanceof e) {
      t.rules.update(i, a);
      return;
    }
    var c = t.style;
    if (s.onUpdate(i, t, u, a), a.process && c && c !== t.style) {
      s.onProcessStyle(t.style, t, u);
      for (var f in t.style) {
        var d = t.style[f], h = c[f];
        d !== h && t.prop(f, d, Fr);
      }
      for (var y in c) {
        var g = t.style[y], p = c[y];
        g == null && g !== p && t.prop(y, null, Fr);
      }
    }
  }, r.toString = function(t) {
    for (var i = "", a = this.options.sheet, o = a ? a.options.link : !1, s = Ne(t), u = s.linebreak, c = 0; c < this.index.length; c++) {
      var f = this.index[c], d = f.toString(t);
      !d && !o || (i && (i += u), i += d);
    }
    return i;
  }, e;
}(), _n = /* @__PURE__ */ function() {
  function e(n, t) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = w({}, t, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), t.Renderer && (this.renderer = new t.Renderer(this)), this.rules = new Ke(this.options);
    for (var i in n)
      this.rules.add(i, n[i]);
    this.rules.process();
  }
  var r = e.prototype;
  return r.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, r.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, r.addRule = function(t, i, a) {
    var o = this.queue;
    this.attached && !o && (this.queue = []);
    var s = this.rules.add(t, i, a);
    return s ? (this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && (o ? o.push(s) : (this.insertRule(s), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), s) : (this.deployed = !1, s)) : null;
  }, r.replaceRule = function(t, i, a) {
    var o = this.rules.get(t);
    if (!o)
      return this.addRule(t, i, a);
    var s = this.rules.replace(t, i, a);
    return s && this.options.jss.plugins.onProcessRule(s), this.attached ? (this.deployed && this.renderer && (s ? o.renderable && this.renderer.replaceRule(o.renderable, s) : this.renderer.deleteRule(o)), s) : (this.deployed = !1, s);
  }, r.insertRule = function(t) {
    this.renderer && this.renderer.insertRule(t);
  }, r.addRules = function(t, i) {
    var a = [];
    for (var o in t) {
      var s = this.addRule(o, t[o], i);
      s && a.push(s);
    }
    return a;
  }, r.getRule = function(t) {
    return this.rules.get(t);
  }, r.deleteRule = function(t) {
    var i = typeof t == "object" ? t : this.rules.get(t);
    return !i || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !i.renderable ? !1 : (this.rules.remove(i), this.attached && i.renderable && this.renderer ? this.renderer.deleteRule(i.renderable) : !0);
  }, r.indexOf = function(t) {
    return this.rules.indexOf(t);
  }, r.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, r.update = function() {
    var t;
    return (t = this.rules).update.apply(t, arguments), this;
  }, r.updateOne = function(t, i, a) {
    return this.rules.updateOne(t, i, a), this;
  }, r.toString = function(t) {
    return this.rules.toString(t);
  }, e;
}(), ta = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var r = e.prototype;
  return r.onCreateRule = function(t, i, a) {
    for (var o = 0; o < this.registry.onCreateRule.length; o++) {
      var s = this.registry.onCreateRule[o](t, i, a);
      if (s)
        return s;
    }
    return null;
  }, r.onProcessRule = function(t) {
    if (!t.isProcessed) {
      for (var i = t.options.sheet, a = 0; a < this.registry.onProcessRule.length; a++)
        this.registry.onProcessRule[a](t, i);
      t.style && this.onProcessStyle(t.style, t, i), t.isProcessed = !0;
    }
  }, r.onProcessStyle = function(t, i, a) {
    for (var o = 0; o < this.registry.onProcessStyle.length; o++)
      i.style = this.registry.onProcessStyle[o](i.style, i, a);
  }, r.onProcessSheet = function(t) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++)
      this.registry.onProcessSheet[i](t);
  }, r.onUpdate = function(t, i, a, o) {
    for (var s = 0; s < this.registry.onUpdate.length; s++)
      this.registry.onUpdate[s](t, i, a, o);
  }, r.onChangeValue = function(t, i, a) {
    for (var o = t, s = 0; s < this.registry.onChangeValue.length; s++)
      o = this.registry.onChangeValue[s](o, i, a);
    return o;
  }, r.use = function(t, i) {
    i === void 0 && (i = {
      queue: "external"
    });
    var a = this.plugins[i.queue];
    a.indexOf(t) === -1 && (a.push(t), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(o, s) {
      for (var u in s)
        u in o ? o[u].push(s[u]) : process.env.NODE_ENV !== "production" && oe(!1, '[JSS] Unknown hook "' + u + '".');
      return o;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), ra = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var r = e.prototype;
  return r.add = function(t) {
    var i = this.registry, a = t.options.index;
    if (i.indexOf(t) === -1) {
      if (i.length === 0 || a >= this.index) {
        i.push(t);
        return;
      }
      for (var o = 0; o < i.length; o++)
        if (i[o].options.index > a) {
          i.splice(o, 0, t);
          return;
        }
    }
  }, r.reset = function() {
    this.registry = [];
  }, r.remove = function(t) {
    var i = this.registry.indexOf(t);
    this.registry.splice(i, 1);
  }, r.toString = function(t) {
    for (var i = t === void 0 ? {} : t, a = i.attached, o = yn(i, ["attached"]), s = Ne(o), u = s.linebreak, c = "", f = 0; f < this.registry.length; f++) {
      var d = this.registry[f];
      a != null && d.attached !== a || (c && (c += u), c += d.toString(o));
    }
    return c;
  }, En(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), Ve = new ra(), kt = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" && window.Math === Math ? window : typeof self != "undefined" && self.Math === Math ? self : Function("return this")(), Dt = "2f1acc6c3a606b082e5eef5e54414ffb";
kt[Dt] == null && (kt[Dt] = 0);
var Ur = kt[Dt]++, na = 1e10, Wr = function(r) {
  r === void 0 && (r = {});
  var n = 0, t = function(a, o) {
    n += 1, n > na && process.env.NODE_ENV !== "production" && oe(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var s = "", u = "";
    return o && (o.options.classNamePrefix && (u = o.options.classNamePrefix), o.options.jss.id != null && (s = String(o.options.jss.id))), r.minify ? "" + (u || "c") + Ur + s + n : u + a.key + "-" + Ur + (s ? "-" + s : "") + "-" + n;
  };
  return t;
}, Pn = function(r) {
  var n;
  return function() {
    return n || (n = r()), n;
  };
}, ia = function(r, n) {
  try {
    return r.attributeStyleMap ? r.attributeStyleMap.get(n) : r.style.getPropertyValue(n);
  } catch (t) {
    return "";
  }
}, aa = function(r, n, t) {
  try {
    var i = t;
    if (Array.isArray(t) && (i = Pe(t)), r.attributeStyleMap)
      r.attributeStyleMap.set(n, i);
    else {
      var a = i ? i.indexOf("!important") : -1, o = a > -1 ? i.substr(0, a - 1) : i;
      r.style.setProperty(n, o, a > -1 ? "important" : "");
    }
  } catch (s) {
    return !1;
  }
  return !0;
}, oa = function(r, n) {
  try {
    r.attributeStyleMap ? r.attributeStyleMap.delete(n) : r.style.removeProperty(n);
  } catch (t) {
    process.env.NODE_ENV !== "production" && oe(!1, '[JSS] DOMException "' + t.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, sa = function(r, n) {
  return r.selectorText = n, r.selectorText === n;
}, xn = Pn(function() {
  return document.querySelector("head");
});
function ua(e, r) {
  for (var n = 0; n < e.length; n++) {
    var t = e[n];
    if (t.attached && t.options.index > r.index && t.options.insertionPoint === r.insertionPoint)
      return t;
  }
  return null;
}
function ca(e, r) {
  for (var n = e.length - 1; n >= 0; n--) {
    var t = e[n];
    if (t.attached && t.options.insertionPoint === r.insertionPoint)
      return t;
  }
  return null;
}
function fa(e) {
  for (var r = xn(), n = 0; n < r.childNodes.length; n++) {
    var t = r.childNodes[n];
    if (t.nodeType === 8 && t.nodeValue.trim() === e)
      return t;
  }
  return null;
}
function la(e) {
  var r = Ve.registry;
  if (r.length > 0) {
    var n = ua(r, e);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = ca(r, e), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var t = e.insertionPoint;
  if (t && typeof t == "string") {
    var i = fa(t);
    if (i)
      return {
        parent: i.parentNode,
        node: i.nextSibling
      };
    process.env.NODE_ENV !== "production" && oe(!1, '[JSS] Insertion point "' + t + '" not found.');
  }
  return !1;
}
function da(e, r) {
  var n = r.insertionPoint, t = la(r);
  if (t !== !1 && t.parent) {
    t.parent.insertBefore(e, t.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var i = n, a = i.parentNode;
    a ? a.insertBefore(e, i.nextSibling) : process.env.NODE_ENV !== "production" && oe(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  xn().appendChild(e);
}
var pa = Pn(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), Lr = function(r, n, t) {
  try {
    "insertRule" in r ? r.insertRule(n, t) : "appendRule" in r && r.appendRule(n);
  } catch (i) {
    return process.env.NODE_ENV !== "production" && oe(!1, "[JSS] " + i.message), !1;
  }
  return r.cssRules[t];
}, qr = function(r, n) {
  var t = r.cssRules.length;
  return n === void 0 || n > t ? t : n;
}, ha = function() {
  var r = document.createElement("style");
  return r.textContent = `
`, r;
}, va = /* @__PURE__ */ function() {
  function e(n) {
    this.getPropertyValue = ia, this.setProperty = aa, this.removeProperty = oa, this.setSelector = sa, this.hasInsertedRules = !1, this.cssRules = [], n && Ve.add(n), this.sheet = n;
    var t = this.sheet ? this.sheet.options : {}, i = t.media, a = t.meta, o = t.element;
    this.element = o || ha(), this.element.setAttribute("data-jss", ""), i && this.element.setAttribute("media", i), a && this.element.setAttribute("data-meta", a);
    var s = pa();
    s && this.element.setAttribute("nonce", s);
  }
  var r = e.prototype;
  return r.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      da(this.element, this.sheet.options);
      var t = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && t && (this.hasInsertedRules = !1, this.deploy());
    }
  }, r.detach = function() {
    if (this.sheet) {
      var t = this.element.parentNode;
      t && t.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, r.deploy = function() {
    var t = this.sheet;
    if (t) {
      if (t.options.link) {
        this.insertRules(t.rules);
        return;
      }
      this.element.textContent = `
` + t.toString() + `
`;
    }
  }, r.insertRules = function(t, i) {
    for (var a = 0; a < t.index.length; a++)
      this.insertRule(t.index[a], a, i);
  }, r.insertRule = function(t, i, a) {
    if (a === void 0 && (a = this.element.sheet), t.rules) {
      var o = t, s = a;
      if (t.type === "conditional" || t.type === "keyframes") {
        var u = qr(a, i);
        if (s = Lr(a, o.toString({
          children: !1
        }), u), s === !1)
          return !1;
        this.refCssRule(t, u, s);
      }
      return this.insertRules(o.rules, s), s;
    }
    var c = t.toString();
    if (!c)
      return !1;
    var f = qr(a, i), d = Lr(a, c, f);
    return d === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(t, f, d), d);
  }, r.refCssRule = function(t, i, a) {
    t.renderable = a, t.options.parent instanceof _n && this.cssRules.splice(i, 0, a);
  }, r.deleteRule = function(t) {
    var i = this.element.sheet, a = this.indexOf(t);
    return a === -1 ? !1 : (i.deleteRule(a), this.cssRules.splice(a, 1), !0);
  }, r.indexOf = function(t) {
    return this.cssRules.indexOf(t);
  }, r.replaceRule = function(t, i) {
    var a = this.indexOf(t);
    return a === -1 ? !1 : (this.element.sheet.deleteRule(a), this.cssRules.splice(a, 1), this.insertRule(i, a));
  }, r.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), ma = 0, ga = /* @__PURE__ */ function() {
  function e(n) {
    this.id = ma++, this.version = "10.10.0", this.plugins = new ta(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: Wr,
      Renderer: Ue ? va : null,
      plugins: []
    }, this.generateId = Wr({
      minify: !1
    });
    for (var t = 0; t < zr.length; t++)
      this.plugins.use(zr[t], {
        queue: "internal"
      });
    this.setup(n);
  }
  var r = e.prototype;
  return r.setup = function(t) {
    return t === void 0 && (t = {}), t.createGenerateId && (this.options.createGenerateId = t.createGenerateId), t.id && (this.options.id = w({}, this.options.id, t.id)), (t.createGenerateId || t.id) && (this.generateId = this.options.createGenerateId(this.options.id)), t.insertionPoint != null && (this.options.insertionPoint = t.insertionPoint), "Renderer" in t && (this.options.Renderer = t.Renderer), t.plugins && this.use.apply(this, t.plugins), this;
  }, r.createStyleSheet = function(t, i) {
    i === void 0 && (i = {});
    var a = i, o = a.index;
    typeof o != "number" && (o = Ve.index === 0 ? 0 : Ve.index + 1);
    var s = new _n(t, w({}, i, {
      jss: this,
      generateId: i.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: o
    }));
    return this.plugins.onProcessSheet(s), s;
  }, r.removeStyleSheet = function(t) {
    return t.detach(), Ve.remove(t), this;
  }, r.createRule = function(t, i, a) {
    if (i === void 0 && (i = {}), a === void 0 && (a = {}), typeof t == "object")
      return this.createRule(void 0, t, i);
    var o = w({}, a, {
      name: t,
      jss: this,
      Renderer: this.options.Renderer
    });
    o.generateId || (o.generateId = this.generateId), o.classes || (o.classes = {}), o.keyframes || (o.keyframes = {});
    var s = Xt(t, i, o);
    return s && this.plugins.onProcessRule(s), s;
  }, r.use = function() {
    for (var t = this, i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return a.forEach(function(s) {
      t.plugins.use(s);
    }), this;
  }, e;
}(), Qt = function(r) {
  return new ga(r);
}, er = typeof CSS == "object" && CSS != null && "number" in CSS;
function On(e) {
  var r = null;
  for (var n in e) {
    var t = e[n], i = typeof t;
    if (i === "function")
      r || (r = {}), r[n] = t;
    else if (i === "object" && t !== null && !Array.isArray(t)) {
      var a = On(t);
      a && (r || (r = {}), r[n] = a);
    }
  }
  return r;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
Qt();
var Tn = Date.now(), ft = "fnValues" + Tn, lt = "fnStyle" + ++Tn, ya = function() {
  return {
    onCreateRule: function(n, t, i) {
      if (typeof t != "function")
        return null;
      var a = Xt(n, {}, i);
      return a[lt] = t, a;
    },
    onProcessStyle: function(n, t) {
      if (ft in t || lt in t)
        return n;
      var i = {};
      for (var a in n) {
        var o = n[a];
        typeof o == "function" && (delete n[a], i[a] = o);
      }
      return t[ft] = i, n;
    },
    onUpdate: function(n, t, i, a) {
      var o = t, s = o[lt];
      if (s && (o.style = s(n) || {}, process.env.NODE_ENV === "development")) {
        for (var u in o.style)
          if (typeof o.style[u] == "function") {
            process.env.NODE_ENV !== "production" && oe(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var c = o[ft];
      if (c)
        for (var f in c)
          o.prop(f, c[f](n), a);
    }
  };
};
const ba = ya;
var ge = "@global", Vt = "@global ", Ea = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "global", this.at = ge, this.isProcessed = !1, this.key = n, this.options = i, this.rules = new Ke(w({}, i, {
      parent: this
    }));
    for (var a in t)
      this.rules.add(a, t[a]);
    this.rules.process();
  }
  var r = e.prototype;
  return r.getRule = function(t) {
    return this.rules.get(t);
  }, r.addRule = function(t, i, a) {
    var o = this.rules.add(t, i, a);
    return o && this.options.jss.plugins.onProcessRule(o), o;
  }, r.replaceRule = function(t, i, a) {
    var o = this.rules.replace(t, i, a);
    return o && this.options.jss.plugins.onProcessRule(o), o;
  }, r.indexOf = function(t) {
    return this.rules.indexOf(t);
  }, r.toString = function(t) {
    return this.rules.toString(t);
  }, e;
}(), Ra = /* @__PURE__ */ function() {
  function e(n, t, i) {
    this.type = "global", this.at = ge, this.isProcessed = !1, this.key = n, this.options = i;
    var a = n.substr(Vt.length);
    this.rule = i.jss.createRule(a, t, w({}, i, {
      parent: this
    }));
  }
  var r = e.prototype;
  return r.toString = function(t) {
    return this.rule ? this.rule.toString(t) : "";
  }, e;
}(), Sa = /\s*,\s*/g;
function wn(e, r) {
  for (var n = e.split(Sa), t = "", i = 0; i < n.length; i++)
    t += r + " " + n[i].trim(), n[i + 1] && (t += ", ");
  return t;
}
function _a(e, r) {
  var n = e.options, t = e.style, i = t ? t[ge] : null;
  if (i) {
    for (var a in i)
      r.addRule(a, i[a], w({}, n, {
        selector: wn(a, e.selector)
      }));
    delete t[ge];
  }
}
function Pa(e, r) {
  var n = e.options, t = e.style;
  for (var i in t)
    if (!(i[0] !== "@" || i.substr(0, ge.length) !== ge)) {
      var a = wn(i.substr(ge.length), e.selector);
      r.addRule(a, t[i], w({}, n, {
        selector: a
      })), delete t[i];
    }
}
function xa() {
  function e(n, t, i) {
    if (!n)
      return null;
    if (n === ge)
      return new Ea(n, t, i);
    if (n[0] === "@" && n.substr(0, Vt.length) === Vt)
      return new Ra(n, t, i);
    var a = i.parent;
    return a && (a.type === "global" || a.options.parent && a.options.parent.type === "global") && (i.scoped = !1), !i.selector && i.scoped === !1 && (i.selector = n), null;
  }
  function r(n, t) {
    n.type !== "style" || !t || (_a(n, t), Pa(n, t));
  }
  return {
    onCreateRule: e,
    onProcessRule: r
  };
}
var Yr = /\s*,\s*/g, Oa = /&/g, Ta = /\$([\w-]+)/g;
function wa() {
  function e(i, a) {
    return function(o, s) {
      var u = i.getRule(s) || a && a.getRule(s);
      return u ? u.selector : (process.env.NODE_ENV !== "production" && oe(!1, '[JSS] Could not find the referenced rule "' + s + '" in "' + (i.options.meta || i.toString()) + '".'), s);
    };
  }
  function r(i, a) {
    for (var o = a.split(Yr), s = i.split(Yr), u = "", c = 0; c < o.length; c++)
      for (var f = o[c], d = 0; d < s.length; d++) {
        var h = s[d];
        u && (u += ", "), u += h.indexOf("&") !== -1 ? h.replace(Oa, f) : f + " " + h;
      }
    return u;
  }
  function n(i, a, o) {
    if (o)
      return w({}, o, {
        index: o.index + 1
      });
    var s = i.options.nestingLevel;
    s = s === void 0 ? 1 : s + 1;
    var u = w({}, i.options, {
      nestingLevel: s,
      index: a.indexOf(i) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete u.name, u;
  }
  function t(i, a, o) {
    if (a.type !== "style")
      return i;
    var s = a, u = s.options.parent, c, f;
    for (var d in i) {
      var h = d.indexOf("&") !== -1, y = d[0] === "@";
      if (!(!h && !y)) {
        if (c = n(s, u, c), h) {
          var g = r(d, s.selector);
          f || (f = e(u, o)), g = g.replace(Ta, f);
          var p = s.key + "-" + d;
          "replaceRule" in u ? u.replaceRule(p, i[d], w({}, c, {
            selector: g
          })) : u.addRule(p, i[d], w({}, c, {
            selector: g
          }));
        } else
          y && u.addRule(d, {}, c).addRule(s.key, i[d], {
            selector: s.selector
          });
        delete i[d];
      }
    }
    return i;
  }
  return {
    onProcessStyle: t
  };
}
var Ca = /[A-Z]/g, Aa = /^ms-/, dt = {};
function Na(e) {
  return "-" + e.toLowerCase();
}
function Cn(e) {
  if (dt.hasOwnProperty(e))
    return dt[e];
  var r = e.replace(Ca, Na);
  return dt[e] = Aa.test(r) ? "-" + r : r;
}
function Ge(e) {
  var r = {};
  for (var n in e) {
    var t = n.indexOf("--") === 0 ? n : Cn(n);
    r[t] = e[n];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? r.fallbacks = e.fallbacks.map(Ge) : r.fallbacks = Ge(e.fallbacks)), r;
}
function Ma() {
  function e(n) {
    if (Array.isArray(n)) {
      for (var t = 0; t < n.length; t++)
        n[t] = Ge(n[t]);
      return n;
    }
    return Ge(n);
  }
  function r(n, t, i) {
    if (t.indexOf("--") === 0)
      return n;
    var a = Cn(t);
    return t === a ? n : (i.prop(a, n), null);
  }
  return {
    onProcessStyle: e,
    onChangeValue: r
  };
}
var l = er && CSS ? CSS.px : "px", We = er && CSS ? CSS.ms : "ms", Oe = er && CSS ? CSS.percent : "%", Ia = {
  // Animation properties
  "animation-delay": We,
  "animation-duration": We,
  // Background properties
  "background-position": l,
  "background-position-x": l,
  "background-position-y": l,
  "background-size": l,
  // Border Properties
  border: l,
  "border-bottom": l,
  "border-bottom-left-radius": l,
  "border-bottom-right-radius": l,
  "border-bottom-width": l,
  "border-left": l,
  "border-left-width": l,
  "border-radius": l,
  "border-right": l,
  "border-right-width": l,
  "border-top": l,
  "border-top-left-radius": l,
  "border-top-right-radius": l,
  "border-top-width": l,
  "border-width": l,
  "border-block": l,
  "border-block-end": l,
  "border-block-end-width": l,
  "border-block-start": l,
  "border-block-start-width": l,
  "border-block-width": l,
  "border-inline": l,
  "border-inline-end": l,
  "border-inline-end-width": l,
  "border-inline-start": l,
  "border-inline-start-width": l,
  "border-inline-width": l,
  "border-start-start-radius": l,
  "border-start-end-radius": l,
  "border-end-start-radius": l,
  "border-end-end-radius": l,
  // Margin properties
  margin: l,
  "margin-bottom": l,
  "margin-left": l,
  "margin-right": l,
  "margin-top": l,
  "margin-block": l,
  "margin-block-end": l,
  "margin-block-start": l,
  "margin-inline": l,
  "margin-inline-end": l,
  "margin-inline-start": l,
  // Padding properties
  padding: l,
  "padding-bottom": l,
  "padding-left": l,
  "padding-right": l,
  "padding-top": l,
  "padding-block": l,
  "padding-block-end": l,
  "padding-block-start": l,
  "padding-inline": l,
  "padding-inline-end": l,
  "padding-inline-start": l,
  // Mask properties
  "mask-position-x": l,
  "mask-position-y": l,
  "mask-size": l,
  // Width and height properties
  height: l,
  width: l,
  "min-height": l,
  "max-height": l,
  "min-width": l,
  "max-width": l,
  // Position properties
  bottom: l,
  left: l,
  top: l,
  right: l,
  inset: l,
  "inset-block": l,
  "inset-block-end": l,
  "inset-block-start": l,
  "inset-inline": l,
  "inset-inline-end": l,
  "inset-inline-start": l,
  // Shadow properties
  "box-shadow": l,
  "text-shadow": l,
  // Column properties
  "column-gap": l,
  "column-rule": l,
  "column-rule-width": l,
  "column-width": l,
  // Font and text properties
  "font-size": l,
  "font-size-delta": l,
  "letter-spacing": l,
  "text-decoration-thickness": l,
  "text-indent": l,
  "text-stroke": l,
  "text-stroke-width": l,
  "word-spacing": l,
  // Motion properties
  motion: l,
  "motion-offset": l,
  // Outline properties
  outline: l,
  "outline-offset": l,
  "outline-width": l,
  // Perspective properties
  perspective: l,
  "perspective-origin-x": Oe,
  "perspective-origin-y": Oe,
  // Transform properties
  "transform-origin": Oe,
  "transform-origin-x": Oe,
  "transform-origin-y": Oe,
  "transform-origin-z": Oe,
  // Transition properties
  "transition-delay": We,
  "transition-duration": We,
  // Alignment properties
  "vertical-align": l,
  "flex-basis": l,
  // Some random properties
  "shape-margin": l,
  size: l,
  gap: l,
  // Grid properties
  grid: l,
  "grid-gap": l,
  "row-gap": l,
  "grid-row-gap": l,
  "grid-column-gap": l,
  "grid-template-rows": l,
  "grid-template-columns": l,
  "grid-auto-rows": l,
  "grid-auto-columns": l,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": l,
  "box-shadow-y": l,
  "box-shadow-blur": l,
  "box-shadow-spread": l,
  "font-line-height": l,
  "text-shadow-x": l,
  "text-shadow-y": l,
  "text-shadow-blur": l
};
function An(e) {
  var r = /(-[a-z])/g, n = function(o) {
    return o[1].toUpperCase();
  }, t = {};
  for (var i in e)
    t[i] = e[i], t[i.replace(r, n)] = e[i];
  return t;
}
var $a = An(Ia);
function ze(e, r, n) {
  if (r == null)
    return r;
  if (Array.isArray(r))
    for (var t = 0; t < r.length; t++)
      r[t] = ze(e, r[t], n);
  else if (typeof r == "object")
    if (e === "fallbacks")
      for (var i in r)
        r[i] = ze(i, r[i], n);
    else
      for (var a in r)
        r[a] = ze(e + "-" + a, r[a], n);
  else if (typeof r == "number" && isNaN(r) === !1) {
    var o = n[e] || $a[e];
    return o && !(r === 0 && o === l) ? typeof o == "function" ? o(r).toString() : "" + r + o : r.toString();
  }
  return r;
}
function ja(e) {
  e === void 0 && (e = {});
  var r = An(e);
  function n(i, a) {
    if (a.type !== "style")
      return i;
    for (var o in i)
      i[o] = ze(o, i[o], r);
    return i;
  }
  function t(i, a) {
    return ze(a, i, r);
  }
  return {
    onProcessStyle: n,
    onChangeValue: t
  };
}
function zt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var n = 0, t = new Array(r); n < r; n++)
    t[n] = e[n];
  return t;
}
function ka(e) {
  if (Array.isArray(e))
    return zt(e);
}
function Da(e) {
  if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Va(e, r) {
  if (e) {
    if (typeof e == "string")
      return zt(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return zt(e, r);
  }
}
function za() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fa(e) {
  return ka(e) || Da(e) || Va(e) || za();
}
var $e = "", Ft = "", Nn = "", Mn = "", Ua = Ue && "ontouchstart" in document.documentElement;
if (Ue) {
  var pt = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, Wa = document.createElement("p"), ht = Wa.style, La = "Transform";
  for (var vt in pt)
    if (vt + La in ht) {
      $e = vt, Ft = pt[vt];
      break;
    }
  $e === "Webkit" && "msHyphens" in ht && ($e = "ms", Ft = pt.ms, Mn = "edge"), $e === "Webkit" && "-apple-trailing-word" in ht && (Nn = "apple");
}
var A = {
  js: $e,
  css: Ft,
  vendor: Nn,
  browser: Mn,
  isTouch: Ua
};
function qa(e) {
  return e[1] === "-" || A.js === "ms" ? e : "@" + A.css + "keyframes" + e.substr(10);
}
var Ya = {
  noPrefill: ["appearance"],
  supportedProperty: function(r) {
    return r !== "appearance" ? !1 : A.js === "ms" ? "-webkit-" + r : A.css + r;
  }
}, Ba = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(r) {
    return r !== "color-adjust" ? !1 : A.js === "Webkit" ? A.css + "print-" + r : r;
  }
}, Ga = /[-\s]+(.)?/g;
function Ha(e, r) {
  return r ? r.toUpperCase() : "";
}
function tr(e) {
  return e.replace(Ga, Ha);
}
function be(e) {
  return tr("-" + e);
}
var Ja = {
  noPrefill: ["mask"],
  supportedProperty: function(r, n) {
    if (!/^mask/.test(r))
      return !1;
    if (A.js === "Webkit") {
      var t = "mask-image";
      if (tr(t) in n)
        return r;
      if (A.js + be(t) in n)
        return A.css + r;
    }
    return r;
  }
}, Ka = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(r) {
    return r !== "text-orientation" ? !1 : A.vendor === "apple" && !A.isTouch ? A.css + r : r;
  }
}, Xa = {
  noPrefill: ["transform"],
  supportedProperty: function(r, n, t) {
    return r !== "transform" ? !1 : t.transform ? r : A.css + r;
  }
}, Za = {
  noPrefill: ["transition"],
  supportedProperty: function(r, n, t) {
    return r !== "transition" ? !1 : t.transition ? r : A.css + r;
  }
}, Qa = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(r) {
    return r !== "writing-mode" ? !1 : A.js === "Webkit" || A.js === "ms" && A.browser !== "edge" ? A.css + r : r;
  }
}, eo = {
  noPrefill: ["user-select"],
  supportedProperty: function(r) {
    return r !== "user-select" ? !1 : A.js === "Moz" || A.js === "ms" || A.vendor === "apple" ? A.css + r : r;
  }
}, to = {
  supportedProperty: function(r, n) {
    if (!/^break-/.test(r))
      return !1;
    if (A.js === "Webkit") {
      var t = "WebkitColumn" + be(r);
      return t in n ? A.css + "column-" + r : !1;
    }
    if (A.js === "Moz") {
      var i = "page" + be(r);
      return i in n ? "page-" + r : !1;
    }
    return !1;
  }
}, ro = {
  supportedProperty: function(r, n) {
    if (!/^(border|margin|padding)-inline/.test(r))
      return !1;
    if (A.js === "Moz")
      return r;
    var t = r.replace("-inline", "");
    return A.js + be(t) in n ? A.css + t : !1;
  }
}, no = {
  supportedProperty: function(r, n) {
    return tr(r) in n ? r : !1;
  }
}, io = {
  supportedProperty: function(r, n) {
    var t = be(r);
    return r[0] === "-" || r[0] === "-" && r[1] === "-" ? r : A.js + t in n ? A.css + r : A.js !== "Webkit" && "Webkit" + t in n ? "-webkit-" + r : !1;
  }
}, ao = {
  supportedProperty: function(r) {
    return r.substring(0, 11) !== "scroll-snap" ? !1 : A.js === "ms" ? "" + A.css + r : r;
  }
}, oo = {
  supportedProperty: function(r) {
    return r !== "overscroll-behavior" ? !1 : A.js === "ms" ? A.css + "scroll-chaining" : r;
  }
}, so = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, uo = {
  supportedProperty: function(r, n) {
    var t = so[r];
    return t && A.js + be(t) in n ? A.css + t : !1;
  }
}, In = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, co = Object.keys(In), fo = function(r) {
  return A.css + r;
}, lo = {
  supportedProperty: function(r, n, t) {
    var i = t.multiple;
    if (co.indexOf(r) > -1) {
      var a = In[r];
      if (!Array.isArray(a))
        return A.js + be(a) in n ? A.css + a : !1;
      if (!i)
        return !1;
      for (var o = 0; o < a.length; o++)
        if (!(A.js + be(a[0]) in n))
          return !1;
      return a.map(fo);
    }
    return !1;
  }
}, $n = [Ya, Ba, Ja, Ka, Xa, Za, Qa, eo, to, ro, no, io, ao, oo, uo, lo], Br = $n.filter(function(e) {
  return e.supportedProperty;
}).map(function(e) {
  return e.supportedProperty;
}), po = $n.filter(function(e) {
  return e.noPrefill;
}).reduce(function(e, r) {
  return e.push.apply(e, Fa(r.noPrefill)), e;
}, []), je, _e = {};
if (Ue) {
  je = document.createElement("p");
  var mt = window.getComputedStyle(document.documentElement, "");
  for (var gt in mt)
    isNaN(gt) || (_e[mt[gt]] = mt[gt]);
  po.forEach(function(e) {
    return delete _e[e];
  });
}
function Ut(e, r) {
  if (r === void 0 && (r = {}), !je)
    return e;
  if (process.env.NODE_ENV !== "benchmark" && _e[e] != null)
    return _e[e];
  (e === "transition" || e === "transform") && (r[e] = e in je.style);
  for (var n = 0; n < Br.length && (_e[e] = Br[n](e, je.style, r), !_e[e]); n++)
    ;
  try {
    je.style[e] = "";
  } catch (t) {
    return !1;
  }
  return _e[e];
}
var Te = {}, ho = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, vo = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, me;
function mo(e, r, n) {
  if (r === "var")
    return "var";
  if (r === "all")
    return "all";
  if (n === "all")
    return ", all";
  var t = r ? Ut(r) : ", " + Ut(n);
  return t || r || n;
}
Ue && (me = document.createElement("p"));
function Gr(e, r) {
  var n = r;
  if (!me || e === "content")
    return r;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var t = e + n;
  if (process.env.NODE_ENV !== "benchmark" && Te[t] != null)
    return Te[t];
  try {
    me.style[e] = n;
  } catch (i) {
    return Te[t] = !1, !1;
  }
  if (ho[e])
    n = n.replace(vo, mo);
  else if (me.style[e] === "" && (n = A.css + n, n === "-ms-flex" && (me.style[e] = "-ms-flexbox"), me.style[e] = n, me.style[e] === ""))
    return Te[t] = !1, !1;
  return me.style[e] = "", Te[t] = n, Te[t];
}
function go() {
  function e(i) {
    if (i.type === "keyframes") {
      var a = i;
      a.at = qa(a.at);
    }
  }
  function r(i) {
    for (var a in i) {
      var o = i[a];
      if (a === "fallbacks" && Array.isArray(o)) {
        i[a] = o.map(r);
        continue;
      }
      var s = !1, u = Ut(a);
      u && u !== a && (s = !0);
      var c = !1, f = Gr(u, Pe(o));
      f && f !== o && (c = !0), (s || c) && (s && delete i[a], i[u || a] = f || o);
    }
    return i;
  }
  function n(i, a) {
    return a.type !== "style" ? i : r(i);
  }
  function t(i, a) {
    return Gr(a, Pe(i)) || i;
  }
  return {
    onProcessRule: e,
    onProcessStyle: n,
    onChangeValue: t
  };
}
function yo() {
  var e = function(n, t) {
    return n.length === t.length ? n > t ? 1 : -1 : n.length - t.length;
  };
  return {
    onProcessStyle: function(n, t) {
      if (t.type !== "style")
        return n;
      for (var i = {}, a = Object.keys(n).sort(e), o = 0; o < a.length; o++)
        i[a[o]] = n[a[o]];
      return i;
    }
  };
}
function jn() {
  return {
    plugins: [
      ba(),
      xa(),
      wa(),
      Ma(),
      ja(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window == "undefined" ? null : go(),
      yo()
    ]
  };
}
function kn() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.baseClasses, n = e.newClasses, t = e.Component;
  if (!n)
    return r;
  var i = w({}, r);
  return process.env.NODE_ENV !== "production" && typeof n == "string" ? (console.error(["Material-UI: The value `".concat(n, "` ") + "provided to the classes prop of ".concat(De(t), " is incorrect."), "You might want to use the className prop instead."].join(`
`)), r) : (Object.keys(n).forEach(function(a) {
    process.env.NODE_ENV !== "production" && (!r[a] && n[a] && console.error(["Material-UI: The key `".concat(a, "` ") + "provided to the classes prop is not implemented in ".concat(De(t), "."), "You can only override one of the following: ".concat(Object.keys(r).join(","), ".")].join(`
`)), n[a] && typeof n[a] != "string" && console.error(["Material-UI: The key `".concat(a, "` ") + "provided to the classes prop is not valid for ".concat(De(t), "."), "You need to provide a non empty string instead of: ".concat(n[a], ".")].join(`
`))), n[a] && (i[a] = "".concat(r[a], " ").concat(n[a]));
  }), i);
}
var bo = {
  set: function(r, n, t, i) {
    var a = r.get(n);
    a || (a = /* @__PURE__ */ new Map(), r.set(n, a)), a.set(t, i);
  },
  get: function(r, n, t) {
    var i = r.get(n);
    return i ? i.get(t) : void 0;
  },
  delete: function(r, n, t) {
    var i = r.get(n);
    i.delete(t);
  }
};
const we = bo;
var Dn = H.createContext(null);
process.env.NODE_ENV !== "production" && (Dn.displayName = "ThemeContext");
const Eo = Dn;
function Vn() {
  var e = H.useContext(Eo);
  return process.env.NODE_ENV !== "production" && H.useDebugValue(e), e;
}
var Ro = Qt(jn()), So = Ai(), _o = /* @__PURE__ */ new Map(), Po = {
  disableGeneration: !1,
  generateClassName: So,
  jss: Ro,
  sheetsCache: null,
  sheetsManager: _o,
  sheetsRegistry: null
}, He = H.createContext(Po);
process.env.NODE_ENV !== "production" && (He.displayName = "StylesContext");
var Le;
function Wt(e) {
  var r = e.children, n = e.injectFirst, t = n === void 0 ? !1 : n, i = e.disableGeneration, a = i === void 0 ? !1 : i, o = fe(e, ["children", "injectFirst", "disableGeneration"]), s = H.useContext(He), u = w({}, s, {
    disableGeneration: a
  }, o);
  if (process.env.NODE_ENV !== "production" && typeof window == "undefined" && !u.sheetsManager && console.error("Material-UI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && u.jss.options.insertionPoint && t && console.error("Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), process.env.NODE_ENV !== "production" && t && o.jss && console.error("Material-UI: You cannot use the jss and injectFirst props at the same time."), !u.jss.options.insertionPoint && t && typeof window != "undefined") {
    if (!Le) {
      var c = document.head;
      Le = document.createComment("mui-inject-first"), c.insertBefore(Le, c.firstChild);
    }
    u.jss = Qt({
      plugins: jn().plugins,
      insertionPoint: Le
    });
  }
  return /* @__PURE__ */ H.createElement(He.Provider, {
    value: u
  }, r);
}
process.env.NODE_ENV !== "production" && (Wt.propTypes = {
  /**
   * Your component tree.
   */
  children: Y.node.isRequired,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: Y.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: Y.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: Y.bool,
  /**
   * JSS's instance.
   */
  jss: Y.object,
  /**
   * @ignore
   */
  serverGenerateClassName: Y.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: Y.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: Y.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: Y.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Wt.propTypes = bi(Wt.propTypes));
var yt = -1e9;
function xo() {
  return yt += 1, process.env.NODE_ENV !== "production" && yt >= 0 && console.warn(["Material-UI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), yt;
}
var Oo = {};
const zn = Oo;
function To(e) {
  var r = typeof e == "function";
  return process.env.NODE_ENV !== "production" && ye(e) !== "object" && !r && console.error(["Material-UI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: function(t, i) {
      var a;
      try {
        a = r ? e(t) : e;
      } catch (u) {
        throw process.env.NODE_ENV !== "production" && r === !0 && t === zn && console.error(["Material-UI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), u;
      }
      if (!i || !t.overrides || !t.overrides[i])
        return a;
      var o = t.overrides[i], s = w({}, a);
      return Object.keys(o).forEach(function(u) {
        process.env.NODE_ENV !== "production" && (s[u] || console.warn(["Material-UI: You are trying to override a style that does not exist.", "Fix the `".concat(u, "` key of `theme.overrides.").concat(i, "`.")].join(`
`))), s[u] = Ce(s[u], o[u]);
      }), s;
    },
    options: {}
  };
}
function wo(e, r, n) {
  var t = e.state, i = e.stylesOptions;
  if (i.disableGeneration)
    return r || {};
  t.cacheClasses || (t.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  var a = !1;
  return t.classes !== t.cacheClasses.lastJSS && (t.cacheClasses.lastJSS = t.classes, a = !0), r !== t.cacheClasses.lastProp && (t.cacheClasses.lastProp = r, a = !0), a && (t.cacheClasses.value = kn({
    baseClasses: t.cacheClasses.lastJSS,
    newClasses: r,
    Component: n
  })), t.cacheClasses.value;
}
function Co(e, r) {
  var n = e.state, t = e.theme, i = e.stylesOptions, a = e.stylesCreator, o = e.name;
  if (!i.disableGeneration) {
    var s = we.get(i.sheetsManager, a, t);
    s || (s = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    }, we.set(i.sheetsManager, a, t, s));
    var u = w({}, a.options, i, {
      theme: t,
      flip: typeof i.flip == "boolean" ? i.flip : t.direction === "rtl"
    });
    u.generateId = u.serverGenerateClassName || u.generateClassName;
    var c = i.sheetsRegistry;
    if (s.refs === 0) {
      var f;
      i.sheetsCache && (f = we.get(i.sheetsCache, a, t));
      var d = a.create(t, o);
      f || (f = i.jss.createStyleSheet(d, w({
        link: !1
      }, u)), f.attach(), i.sheetsCache && we.set(i.sheetsCache, a, t, f)), c && c.add(f), s.staticSheet = f, s.dynamicStyles = On(d);
    }
    if (s.dynamicStyles) {
      var h = i.jss.createStyleSheet(s.dynamicStyles, w({
        link: !0
      }, u));
      h.update(r), h.attach(), n.dynamicSheet = h, n.classes = kn({
        baseClasses: s.staticSheet.classes,
        newClasses: h.classes
      }), c && c.add(h);
    } else
      n.classes = s.staticSheet.classes;
    s.refs += 1;
  }
}
function Ao(e, r) {
  var n = e.state;
  n.dynamicSheet && n.dynamicSheet.update(r);
}
function No(e) {
  var r = e.state, n = e.theme, t = e.stylesOptions, i = e.stylesCreator;
  if (!t.disableGeneration) {
    var a = we.get(t.sheetsManager, i, n);
    a.refs -= 1;
    var o = t.sheetsRegistry;
    a.refs === 0 && (we.delete(t.sheetsManager, i, n), t.jss.removeStyleSheet(a.staticSheet), o && o.remove(a.staticSheet)), r.dynamicSheet && (t.jss.removeStyleSheet(r.dynamicSheet), o && o.remove(r.dynamicSheet));
  }
}
function Mo(e, r) {
  var n = H.useRef([]), t, i = H.useMemo(function() {
    return {};
  }, r);
  n.current !== i && (n.current = i, t = e()), H.useEffect(
    function() {
      return function() {
        t && t();
      };
    },
    [i]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function Io(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = r.name, t = r.classNamePrefix, i = r.Component, a = r.defaultTheme, o = a === void 0 ? zn : a, s = fe(r, ["name", "classNamePrefix", "Component", "defaultTheme"]), u = To(e), c = n || t || "makeStyles";
  u.options = {
    index: xo(),
    name: n,
    meta: c,
    classNamePrefix: c
  };
  var f = function() {
    var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, y = Vn() || o, g = w({}, H.useContext(He), s), p = H.useRef(), _ = H.useRef();
    Mo(function() {
      var I = {
        name: n,
        state: {},
        stylesCreator: u,
        stylesOptions: g,
        theme: y
      };
      return Co(I, h), _.current = !1, p.current = I, function() {
        No(I);
      };
    }, [y, u]), H.useEffect(function() {
      _.current && Ao(p.current, h), _.current = !0;
    });
    var b = wo(p.current, h.classes, i);
    return process.env.NODE_ENV !== "production" && H.useDebugValue(b), b;
  };
  return f;
}
var rr = Jt(), $o = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, jo = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, ko = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Fn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, nr = {};
nr[rr.ForwardRef] = ko;
nr[rr.Memo] = Fn;
function Hr(e) {
  return rr.isMemo(e) ? Fn : nr[e.$$typeof] || $o;
}
var Do = Object.defineProperty, Vo = Object.getOwnPropertyNames, Jr = Object.getOwnPropertySymbols, zo = Object.getOwnPropertyDescriptor, Fo = Object.getPrototypeOf, Kr = Object.prototype;
function Un(e, r, n) {
  if (typeof r != "string") {
    if (Kr) {
      var t = Fo(r);
      t && t !== Kr && Un(e, t, n);
    }
    var i = Vo(r);
    Jr && (i = i.concat(Jr(r)));
    for (var a = Hr(e), o = Hr(r), s = 0; s < i.length; ++s) {
      var u = i[s];
      if (!jo[u] && !(n && n[u]) && !(o && o[u]) && !(a && a[u])) {
        var c = zo(r, u);
        try {
          Do(e, u, c);
        } catch (f) {
        }
      }
    }
  }
  return e;
}
var Uo = Un, Wo = function(r) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(t) {
    var i = n.defaultTheme, a = n.withTheme, o = a === void 0 ? !1 : a, s = n.name, u = fe(n, ["defaultTheme", "withTheme", "name"]);
    if (process.env.NODE_ENV !== "production" && t === void 0)
      throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    var c = s;
    if (process.env.NODE_ENV !== "production" && !s) {
      var f = De(t);
      f !== void 0 && (c = f);
    }
    var d = Io(r, w({
      defaultTheme: i,
      Component: t,
      name: s || t.displayName,
      classNamePrefix: c
    }, u)), h = /* @__PURE__ */ H.forwardRef(function(g, p) {
      g.classes;
      var _ = g.innerRef, b = fe(g, ["classes", "innerRef"]), I = d(w({}, t.defaultProps, g)), x, O = b;
      return (typeof s == "string" || o) && (x = Vn() || i, s && (O = Ni({
        theme: x,
        name: s,
        props: b
      })), o && !O.theme && (O.theme = x)), /* @__PURE__ */ H.createElement(t, w({
        ref: _ || p,
        classes: I
      }, O));
    });
    return process.env.NODE_ENV !== "production" && (h.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: Y.object,
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: hn(Y.oneOfType([Y.func, Y.object]), function(y) {
        return y.innerRef == null, null;
      })
    }), process.env.NODE_ENV !== "production" && (h.displayName = "WithStyles(".concat(De(t), ")")), Uo(h, t), process.env.NODE_ENV !== "production" && (h.Naked = t, h.options = n, h.useStyles = d), h;
  };
};
const Lo = Wo;
var he = ["xs", "sm", "md", "lg", "xl"];
function qo(e) {
  var r = e.values, n = r === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : r, t = e.unit, i = t === void 0 ? "px" : t, a = e.step, o = a === void 0 ? 5 : a, s = fe(e, ["values", "unit", "step"]);
  function u(g) {
    var p = typeof n[g] == "number" ? n[g] : g;
    return "@media (min-width:".concat(p).concat(i, ")");
  }
  function c(g) {
    var p = he.indexOf(g) + 1, _ = n[he[p]];
    if (p === he.length)
      return u("xs");
    var b = typeof _ == "number" && p > 0 ? _ : g;
    return "@media (max-width:".concat(b - o / 100).concat(i, ")");
  }
  function f(g, p) {
    var _ = he.indexOf(p);
    return _ === he.length - 1 ? u(g) : "@media (min-width:".concat(typeof n[g] == "number" ? n[g] : g).concat(i, ") and ") + "(max-width:".concat((_ !== -1 && typeof n[he[_ + 1]] == "number" ? n[he[_ + 1]] : p) - o / 100).concat(i, ")");
  }
  function d(g) {
    return f(g, g);
  }
  var h = !1;
  function y(g) {
    return process.env.NODE_ENV !== "production" && (h || (h = !0, console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", "Use the `theme.breakpoints.values` instead."].join(`
`)))), n[g];
  }
  return w({
    keys: he,
    values: n,
    up: u,
    down: c,
    between: f,
    only: d,
    width: y
  }, s);
}
function Yo(e, r, n) {
  var t;
  return w({
    gutters: function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", `
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
      `].join(`
`)), w({
        paddingLeft: r(2),
        paddingRight: r(2)
      }, a, ke({}, e.up("sm"), w({
        paddingLeft: r(3),
        paddingRight: r(3)
      }, a[e.up("sm")])));
    },
    toolbar: (t = {
      minHeight: 56
    }, ke(t, "".concat(e.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), ke(t, e.up("sm"), {
      minHeight: 64
    }), t)
  }, n);
}
var Bo = {
  black: "#000",
  white: "#fff"
};
const Je = Bo;
var Go = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
const ir = Go;
var Ho = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
};
const bt = Ho;
var Jo = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
};
const Et = Jo;
var Ko = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
const Rt = Ko;
var Xo = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
const St = Xo;
var Zo = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
const _t = Zo;
var Qo = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
const Pt = Qo;
function Wn(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return process.env.NODE_ENV !== "production" && (e < r || e > n) && console.error("Material-UI: The value provided ".concat(e, " is out of range [").concat(r, ", ").concat(n, "].")), Math.min(Math.max(r, e), n);
}
function es(e) {
  e = e.substr(1);
  var r = new RegExp(".{1,".concat(e.length >= 6 ? 2 : 1, "}"), "g"), n = e.match(r);
  return n && n[0].length === 1 && (n = n.map(function(t) {
    return t + t;
  })), n ? "rgb".concat(n.length === 4 ? "a" : "", "(").concat(n.map(function(t, i) {
    return i < 3 ? parseInt(t, 16) : Math.round(parseInt(t, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function ts(e) {
  e = Ae(e);
  var r = e, n = r.values, t = n[0], i = n[1] / 100, a = n[2] / 100, o = i * Math.min(a, 1 - a), s = function(d) {
    var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (d + t / 30) % 12;
    return a - o * Math.max(Math.min(h - 3, 9 - h, 1), -1);
  }, u = "rgb", c = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (u += "a", c.push(n[3])), ar({
    type: u,
    values: c
  });
}
function Ae(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Ae(es(e));
  var r = e.indexOf("("), n = e.substring(0, r);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: Unsupported `".concat(e, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Ye(3, e));
  var t = e.substring(r + 1, e.length - 1).split(",");
  return t = t.map(function(i) {
    return parseFloat(i);
  }), {
    type: n,
    values: t
  };
}
function ar(e) {
  var r = e.type, n = e.values;
  return r.indexOf("rgb") !== -1 ? n = n.map(function(t, i) {
    return i < 3 ? parseInt(t, 10) : t;
  }) : r.indexOf("hsl") !== -1 && (n[1] = "".concat(n[1], "%"), n[2] = "".concat(n[2], "%")), "".concat(r, "(").concat(n.join(", "), ")");
}
function Xr(e, r) {
  var n = Zr(e), t = Zr(r);
  return (Math.max(n, t) + 0.05) / (Math.min(n, t) + 0.05);
}
function Zr(e) {
  e = Ae(e);
  var r = e.type === "hsl" ? Ae(ts(e)).values : e.values;
  return r = r.map(function(n) {
    return n /= 255, n <= 0.03928 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
  }), Number((0.2126 * r[0] + 0.7152 * r[1] + 0.0722 * r[2]).toFixed(3));
}
function rs(e, r) {
  if (e = Ae(e), r = Wn(r), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - r;
  else if (e.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      e.values[n] *= 1 - r;
  return ar(e);
}
function ns(e, r) {
  if (e = Ae(e), r = Wn(r), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * r;
  else if (e.type.indexOf("rgb") !== -1)
    for (var n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * r;
  return ar(e);
}
var Qr = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: Je.white,
    default: ir[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, xt = {
  text: {
    primary: Je.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: ir[800],
    default: "#303030"
  },
  action: {
    active: Je.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function en(e, r, n, t) {
  var i = t.light || t, a = t.dark || t * 1.5;
  e[r] || (e.hasOwnProperty(n) ? e[r] = e[n] : r === "light" ? e.light = ns(e.main, i) : r === "dark" && (e.dark = rs(e.main, a)));
}
function is(e) {
  var r = e.primary, n = r === void 0 ? {
    light: bt[300],
    main: bt[500],
    dark: bt[700]
  } : r, t = e.secondary, i = t === void 0 ? {
    light: Et.A200,
    main: Et.A400,
    dark: Et.A700
  } : t, a = e.error, o = a === void 0 ? {
    light: Rt[300],
    main: Rt[500],
    dark: Rt[700]
  } : a, s = e.warning, u = s === void 0 ? {
    light: St[300],
    main: St[500],
    dark: St[700]
  } : s, c = e.info, f = c === void 0 ? {
    light: _t[300],
    main: _t[500],
    dark: _t[700]
  } : c, d = e.success, h = d === void 0 ? {
    light: Pt[300],
    main: Pt[500],
    dark: Pt[700]
  } : d, y = e.type, g = y === void 0 ? "light" : y, p = e.contrastThreshold, _ = p === void 0 ? 3 : p, b = e.tonalOffset, I = b === void 0 ? 0.2 : b, x = fe(e, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function O(J) {
    var $ = Xr(J, xt.text.primary) >= _ ? xt.text.primary : Qr.text.primary;
    if (process.env.NODE_ENV !== "production") {
      var X = Xr(J, $);
      X < 3 && console.error(["Material-UI: The contrast ratio of ".concat(X, ":1 for ").concat($, " on ").concat(J), "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return $;
  }
  var v = function($) {
    var X = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500, re = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300, Z = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    if ($ = w({}, $), !$.main && $[X] && ($.main = $[X]), !$.main)
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(X, "` property.") : Ye(4, X));
    if (typeof $.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify($.main), `\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@material-ui/core/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`) : Ye(5, JSON.stringify($.main)));
    return en($, "light", re, I), en($, "dark", Z, I), $.contrastText || ($.contrastText = O($.main)), $;
  }, U = {
    dark: xt,
    light: Qr
  };
  process.env.NODE_ENV !== "production" && (U[g] || console.error("Material-UI: The palette type `".concat(g, "` is not supported.")));
  var te = Ce(w({
    // A collection of common colors.
    common: Je,
    // The palette type, can be light or dark.
    type: g,
    // The colors used to represent primary interface elements for a user.
    primary: v(n),
    // The colors used to represent secondary interface elements for a user.
    secondary: v(i, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: v(o),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: v(u),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: v(f),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: v(h),
    // The grey colors.
    grey: ir,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: _,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: O,
    // Generate a rich color object.
    augmentColor: v,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: I
  }, U[g]), x);
  return te;
}
function Ln(e) {
  return Math.round(e * 1e5) / 1e5;
}
var tn = !1;
function as(e) {
  return process.env.NODE_ENV !== "production" && (tn || (console.warn(["Material-UI: The `theme.typography.round` helper is deprecated.", "Head to https://mui.com/r/migration-v4/#theme for a migration path."].join(`
`)), tn = !0)), Ln(e);
}
var rn = {
  textTransform: "uppercase"
}, nn = '"Roboto", "Helvetica", "Arial", sans-serif';
function os(e, r) {
  var n = typeof r == "function" ? r(e) : r, t = n.fontFamily, i = t === void 0 ? nn : t, a = n.fontSize, o = a === void 0 ? 14 : a, s = n.fontWeightLight, u = s === void 0 ? 300 : s, c = n.fontWeightRegular, f = c === void 0 ? 400 : c, d = n.fontWeightMedium, h = d === void 0 ? 500 : d, y = n.fontWeightBold, g = y === void 0 ? 700 : y, p = n.htmlFontSize, _ = p === void 0 ? 16 : p, b = n.allVariants, I = n.pxToRem, x = fe(n, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("Material-UI: `fontSize` is required to be a number."), typeof _ != "number" && console.error("Material-UI: `htmlFontSize` is required to be a number."));
  var O = o / 14, v = I || function(J) {
    return "".concat(J / _ * O, "rem");
  }, U = function($, X, re, Z, R) {
    return w({
      fontFamily: i,
      fontWeight: $,
      fontSize: v(X),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: re
    }, i === nn ? {
      letterSpacing: "".concat(Ln(Z / X), "em")
    } : {}, R, b);
  }, te = {
    h1: U(u, 96, 1.167, -1.5),
    h2: U(u, 60, 1.2, -0.5),
    h3: U(f, 48, 1.167, 0),
    h4: U(f, 34, 1.235, 0.25),
    h5: U(f, 24, 1.334, 0),
    h6: U(h, 20, 1.6, 0.15),
    subtitle1: U(f, 16, 1.75, 0.15),
    subtitle2: U(h, 14, 1.57, 0.1),
    body1: U(f, 16, 1.5, 0.15),
    body2: U(f, 14, 1.43, 0.15),
    button: U(h, 14, 1.75, 0.4, rn),
    caption: U(f, 12, 1.66, 0.4),
    overline: U(f, 12, 2.66, 1, rn)
  };
  return Ce(w({
    htmlFontSize: _,
    pxToRem: v,
    round: as,
    // TODO v5: remove
    fontFamily: i,
    fontSize: o,
    fontWeightLight: u,
    fontWeightRegular: f,
    fontWeightMedium: h,
    fontWeightBold: g
  }, te), x, {
    clone: !1
    // No need to clone deep
  });
}
var ss = 0.2, us = 0.14, cs = 0.12;
function K() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(ss, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(us, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(cs, ")")].join(",");
}
var fs = ["none", K(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), K(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), K(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), K(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), K(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), K(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), K(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), K(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), K(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), K(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), K(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), K(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), K(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), K(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), K(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), K(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), K(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), K(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), K(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), K(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), K(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), K(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), K(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), K(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
const ls = fs;
var ds = {
  borderRadius: 4
};
const ps = ds;
var hs = process.env.NODE_ENV !== "production" ? Y.oneOfType([Y.number, Y.string, Y.object, Y.array]) : {};
const vs = hs;
var ms = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function gs(e) {
  var r = e.spacing || 8;
  return typeof r == "number" ? function(n) {
    return process.env.NODE_ENV !== "production" && typeof n != "number" && console.error("Material-UI: Expected spacing argument to be a number, got ".concat(n, ".")), r * n;
  } : Array.isArray(r) ? function(n) {
    return process.env.NODE_ENV !== "production" && n > r.length - 1 && console.error(["Material-UI: The value provided (".concat(n, ") overflows."), "The supported values are: ".concat(JSON.stringify(r), "."), "".concat(n, " > ").concat(r.length - 1, ", you need to add the missing values.")].join(`
`)), r[n];
  } : typeof r == "function" ? r : (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `theme.spacing` value (".concat(r, ") is invalid."), "It should be a number, an array or a function."].join(`
`)), function() {
  });
}
process.env.NODE_ENV !== "production" && ms.reduce(function(e, r) {
  return e[r] = vs, e;
}, {});
var an;
function ys() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (e.mui)
    return e;
  var r = gs({
    spacing: e
  }), n = function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return process.env.NODE_ENV !== "production" && (a.length <= 4 || console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(a.length))), a.length === 0 ? r(1) : a.length === 1 ? r(a[0]) : a.map(function(s) {
      if (typeof s == "string")
        return s;
      var u = r(s);
      return typeof u == "number" ? "".concat(u, "px") : u;
    }).join(" ");
  };
  return Object.defineProperty(n, "unit", {
    get: function() {
      return process.env.NODE_ENV !== "production" && ((!an || process.env.NODE_ENV === "test") && console.error(["Material-UI: theme.spacing.unit usage has been deprecated.", "It will be removed in v5.", "You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.", "", "You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother."].join(`
`)), an = !0), e;
    }
  }), n.mui = !0, n;
}
var on = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, sn = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function un(e) {
  return "".concat(Math.round(e), "ms");
}
const bs = {
  easing: on,
  duration: sn,
  create: function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.duration, i = t === void 0 ? sn.standard : t, a = n.easing, o = a === void 0 ? on.easeInOut : a, s = n.delay, u = s === void 0 ? 0 : s, c = fe(n, ["duration", "easing", "delay"]);
    if (process.env.NODE_ENV !== "production") {
      var f = function(y) {
        return typeof y == "string";
      }, d = function(y) {
        return !isNaN(parseFloat(y));
      };
      !f(r) && !Array.isArray(r) && console.error('Material-UI: Argument "props" must be a string or Array.'), !d(i) && !f(i) && console.error('Material-UI: Argument "duration" must be a number or a string but found '.concat(i, ".")), f(o) || console.error('Material-UI: Argument "easing" must be a string.'), !d(u) && !f(u) && console.error('Material-UI: Argument "delay" must be a number or a string.'), Object.keys(c).length !== 0 && console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(c).join(","), "]."));
    }
    return (Array.isArray(r) ? r : [r]).map(function(h) {
      return "".concat(h, " ").concat(typeof i == "string" ? i : un(i), " ").concat(o, " ").concat(typeof u == "string" ? u : un(u));
    }).join(",");
  },
  getAutoHeightDuration: function(r) {
    if (!r)
      return 0;
    var n = r / 36;
    return Math.round((4 + 15 * Math.pow(n, 0.25) + n / 5) * 10);
  }
};
var Es = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
const Rs = Es;
function Ss() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = e.breakpoints, n = r === void 0 ? {} : r, t = e.mixins, i = t === void 0 ? {} : t, a = e.palette, o = a === void 0 ? {} : a, s = e.spacing, u = e.typography, c = u === void 0 ? {} : u, f = fe(e, ["breakpoints", "mixins", "palette", "spacing", "typography"]), d = is(o), h = qo(n), y = ys(s), g = Ce({
    breakpoints: h,
    direction: "ltr",
    mixins: Yo(h, y, i),
    overrides: {},
    // Inject custom styles
    palette: d,
    props: {},
    // Provide default props
    shadows: ls,
    typography: os(d, c),
    spacing: y,
    shape: ps,
    transitions: bs,
    zIndex: Rs
  }, f), p = arguments.length, _ = new Array(p > 1 ? p - 1 : 0), b = 1; b < p; b++)
    _[b - 1] = arguments[b];
  if (g = _.reduce(function(O, v) {
    return Ce(O, v);
  }, g), process.env.NODE_ENV !== "production") {
    var I = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"], x = function O(v, U) {
      var te = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, J;
      for (J in v) {
        var $ = v[J];
        te === 1 ? J.indexOf("Mui") === 0 && $ && O($, J, te + 1) : I.indexOf(J) !== -1 && Object.keys($).length > 0 && (process.env.NODE_ENV !== "production" && console.error(["Material-UI: The `".concat(U, "` component increases ") + "the CSS specificity of the `".concat(J, "` internal state."), "You can not override it like this: ", JSON.stringify(v, null, 2), "", "Instead, you need to use the $ruleName syntax:", JSON.stringify({
          root: ke({}, "&$".concat(J), $)
        }, null, 2), "", "https://mui.com/r/pseudo-classes-guide"].join(`
`)), v[J] = {});
      }
    };
    x(g.overrides);
  }
  return g;
}
var _s = Ss();
const Ps = _s;
function xs(e, r) {
  return Lo(e, w({
    defaultTheme: Ps
  }, r));
}
var Os = function(r) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: r.typography.pxToRem(24),
      transition: r.transitions.create("fill", {
        duration: r.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: r.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: r.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: r.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: r.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: r.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: r.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: r.typography.pxToRem(35)
    }
  };
}, or = /* @__PURE__ */ Q.forwardRef(function(r, n) {
  var t = r.children, i = r.classes, a = r.className, o = r.color, s = o === void 0 ? "inherit" : o, u = r.component, c = u === void 0 ? "svg" : u, f = r.fontSize, d = f === void 0 ? "medium" : f, h = r.htmlColor, y = r.titleAccess, g = r.viewBox, p = g === void 0 ? "0 0 24 24" : g, _ = fe(r, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ Q.createElement(c, w({
    className: Oi(i.root, a, s !== "inherit" && i["color".concat(At(s))], d !== "default" && d !== "medium" && i["fontSize".concat(At(d))]),
    focusable: "false",
    viewBox: p,
    color: h,
    "aria-hidden": y ? void 0 : !0,
    role: y ? "img" : void 0,
    ref: n
  }, _), t, y ? /* @__PURE__ */ Q.createElement("title", null, y) : null);
});
process.env.NODE_ENV !== "production" && (or.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Node passed into the SVG element.
   */
  children: Y.node,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: Y.object,
  /**
   * @ignore
   */
  className: Y.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: Y.oneOf(["action", "disabled", "error", "inherit", "primary", "secondary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: Y.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: hn(Y.oneOf(["default", "inherit", "large", "medium", "small"]), function(e) {
    var r = e.fontSize;
    if (r === "default")
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    return null;
  }),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: Y.string,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: Y.string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: Y.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: Y.string
});
or.muiName = "SvgIcon";
const cn = xs(Os, {
  name: "MuiSvgIcon"
})(or);
function Ts(e, r) {
  var n = function(i, a) {
    return /* @__PURE__ */ H.createElement(cn, w({
      ref: a
    }, i), e);
  };
  return process.env.NODE_ENV !== "production" && (n.displayName = "".concat(r, "Icon")), n.muiName = cn.muiName, /* @__PURE__ */ H.memo(/* @__PURE__ */ H.forwardRef(n));
}
function ws(e) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166, n;
  function t() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    var s = this, u = function() {
      e.apply(s, a);
    };
    clearTimeout(n), n = setTimeout(u, r);
  }
  return t.clear = function() {
    clearTimeout(n);
  }, t;
}
function Cs(e, r) {
  return process.env.NODE_ENV === "production" ? function() {
    return null;
  } : function(n, t, i, a, o) {
    var s = i || "<<anonymous>>", u = o || t;
    return typeof n[t] != "undefined" ? new Error("The ".concat(a, " `").concat(u, "` of ") + "`".concat(s, "` is deprecated. ").concat(r)) : null;
  };
}
function As(e, r) {
  return /* @__PURE__ */ Q.isValidElement(e) && r.indexOf(e.type.muiName) !== -1;
}
function qn(e) {
  return e && e.ownerDocument || document;
}
function Ns(e) {
  var r = qn(e);
  return r.defaultView || window;
}
function Ms(e) {
  if (process.env.NODE_ENV === "production")
    return function() {
      return null;
    };
  var r = function(t) {
    return function(i, a, o, s, u) {
      var c = u || a;
      return typeof i[a] != "undefined" && !i[t] ? new Error("The prop `".concat(c, "` of ") + "`".concat(e, "` must be used on `").concat(t, "`.")) : null;
    };
  };
  return r;
}
function Lt(e, r) {
  typeof e == "function" ? e(r) : e && (e.current = r);
}
function Is(e, r, n, t, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  var a = i || r;
  return typeof e[r] != "undefined" ? new Error("The prop `".concat(a, "` is not supported. Please remove it.")) : null;
}
function $s(e) {
  var r = e.controlled, n = e.default, t = e.name, i = e.state, a = i === void 0 ? "value" : i, o = Q.useRef(r !== void 0), s = o.current, u = Q.useState(n), c = u[0], f = u[1], d = s ? r : c;
  if (process.env.NODE_ENV !== "production") {
    Q.useEffect(function() {
      s !== (r !== void 0) && console.error(["Material-UI: A component is changing the ".concat(s ? "" : "un", "controlled ").concat(a, " state of ").concat(t, " to be ").concat(s ? "un" : "", "controlled."), "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled ".concat(t, " ") + "element for the lifetime of the component.", "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r]);
    var h = Q.useRef(n), y = h.current;
    Q.useEffect(function() {
      !s && y !== n && console.error(["Material-UI: A component is changing the default ".concat(a, " state of an uncontrolled ").concat(t, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(t, ".")].join(`
`));
    }, [JSON.stringify(n)]);
  }
  var g = Q.useCallback(function(p) {
    s || f(p);
  }, []);
  return [d, g];
}
var js = typeof window != "undefined" ? Q.useLayoutEffect : Q.useEffect;
function ks(e) {
  var r = Q.useRef(e);
  return js(function() {
    r.current = e;
  }), Q.useCallback(function() {
    return r.current.apply(void 0, arguments);
  }, []);
}
function Ds(e, r) {
  return Q.useMemo(function() {
    return e == null && r == null ? null : function(n) {
      Lt(e, n), Lt(r, n);
    };
  }, [e, r]);
}
function Vs(e) {
  var r = Q.useState(e), n = r[0], t = r[1], i = e || n;
  return Q.useEffect(function() {
    n == null && t("mui-".concat(Math.round(Math.random() * 1e5)));
  }, [n]), i;
}
var Xe = !0, qt = !1, fn = null, zs = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Fs(e) {
  var r = e.type, n = e.tagName;
  return !!(n === "INPUT" && zs[r] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Us(e) {
  e.metaKey || e.altKey || e.ctrlKey || (Xe = !0);
}
function Ot() {
  Xe = !1;
}
function Ws() {
  this.visibilityState === "hidden" && qt && (Xe = !0);
}
function Ls(e) {
  e.addEventListener("keydown", Us, !0), e.addEventListener("mousedown", Ot, !0), e.addEventListener("pointerdown", Ot, !0), e.addEventListener("touchstart", Ot, !0), e.addEventListener("visibilitychange", Ws, !0);
}
function ln(e) {
  var r = e.target;
  try {
    return r.matches(":focus-visible");
  } catch (n) {
  }
  return Xe || Fs(r);
}
function qs() {
  qt = !0, window.clearTimeout(fn), fn = window.setTimeout(function() {
    qt = !1;
  }, 100);
}
function Ys() {
  var e = Q.useCallback(function(r) {
    var n = ni.findDOMNode(r);
    n != null && Ls(n.ownerDocument);
  }, []);
  return process.env.NODE_ENV !== "production" && Q.useDebugValue(ln), {
    isFocusVisible: ln,
    onBlurVisible: qs,
    ref: e
  };
}
const Bs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: At,
  createChainedFunction: xi,
  createSvgIcon: Ts,
  debounce: ws,
  deprecatedPropType: Cs,
  isMuiElement: As,
  ownerDocument: qn,
  ownerWindow: Ns,
  requirePropFactory: Ms,
  setRef: Lt,
  unstable_useId: Vs,
  unsupportedProp: Is,
  useControlled: $s,
  useEventCallback: ks,
  useForkRef: Ds,
  useIsFocusVisible: Ys
}, Symbol.toStringTag, { value: "Module" })), Gs = /* @__PURE__ */ ii(Bs);
var dn;
function Ee() {
  return dn || (dn = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return r.createSvgIcon;
      }
    });
    var r = Gs;
  }(et)), et;
}
var Hs = ue, Js = ce;
Object.defineProperty(Ht, "__esModule", {
  value: !0
});
var sr = Ht.default = void 0, Ks = Js(H), Xs = Hs(Ee()), Zs = (0, Xs.default)(/* @__PURE__ */ Ks.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), "Edit");
sr = Ht.default = Zs;
var ur = {}, Qs = ue, eu = ce;
Object.defineProperty(ur, "__esModule", {
  value: !0
});
var cr = ur.default = void 0, tu = eu(H), ru = Qs(Ee()), nu = (0, ru.default)(/* @__PURE__ */ tu.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
cr = ur.default = nu;
var fr = {}, iu = ue, au = ce;
Object.defineProperty(fr, "__esModule", {
  value: !0
});
var Yn = fr.default = void 0, ou = au(H), su = iu(Ee()), uu = (0, su.default)(/* @__PURE__ */ ou.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), "Visibility");
Yn = fr.default = uu;
var lr = {}, cu = ue, fu = ce;
Object.defineProperty(lr, "__esModule", {
  value: !0
});
var Yt = lr.default = void 0, lu = fu(H), du = cu(Ee()), pu = (0, du.default)(/* @__PURE__ */ lu.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
Yt = lr.default = pu;
var dr = {}, hu = ue, vu = ce;
Object.defineProperty(dr, "__esModule", {
  value: !0
});
var Bn = dr.default = void 0, mu = vu(H), gu = hu(Ee()), yu = (0, gu.default)(/* @__PURE__ */ mu.createElement("path", {
  d: "M21 6h-4c0-2.76-2.24-5-5-5S7 3.24 7 6H3v16h18V6zm-9-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
}), "LocalMallSharp");
Bn = dr.default = yu;
var pr = {}, bu = ue, Eu = ce;
Object.defineProperty(pr, "__esModule", {
  value: !0
});
var Gn = pr.default = void 0, Ru = Eu(H), Su = bu(Ee()), _u = (0, Su.default)(/* @__PURE__ */ Ru.createElement("path", {
  d: "M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"
}), "ListAlt");
Gn = pr.default = _u;
var hr = {}, Pu = ue, xu = ce;
Object.defineProperty(hr, "__esModule", {
  value: !0
});
var Bt = hr.default = void 0, Ou = xu(H), Tu = Pu(Ee()), wu = (0, Tu.default)(/* @__PURE__ */ Ou.createElement("path", {
  d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
}), "Queue");
Bt = hr.default = wu;
var vr = {}, Cu = ue, Au = ce;
Object.defineProperty(vr, "__esModule", {
  value: !0
});
var Gt = vr.default = void 0, Nu = Au(H), Mu = Cu(Ee()), Iu = (0, Mu.default)(/* @__PURE__ */ Nu.createElement("path", {
  d: "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
}), "ClearAll");
Gt = vr.default = Iu;
const ve = "text-gray-400 dark:hover:text-gray-300 dark:text-gray-400", $u = (e) => {
  const {
    loadProductGroupRules: r,
    showRecord: n,
    row: t,
    typeMenu: i,
    cleanCpfs: a,
    loadCpfs: o,
    loadCnpjs: s,
    editRecord: u,
    priorityEnable: c,
    enableButtonPriority: f,
    deleteRecord: d,
    refetch: h
  } = e, y = [
    {
      label: "Grupo de Produtos",
      icon: /* @__PURE__ */ T(Bt, {}),
      onClick: (p) => n && n(p)
    },
    {
      label: "Carga de Regras",
      icon: /* @__PURE__ */ T(Gt, {}),
      onClick: (p) => r && r(p)
    }
  ], g = [
    {
      label: "Carga CPFs",
      icon: /* @__PURE__ */ T(Bt, {}),
      onClick: (p) => o && o(p)
    },
    {
      label: "Higienização",
      icon: /* @__PURE__ */ T(Gt, {}),
      onClick: (p) => a && a(p)
    }
  ];
  return [
    {
      show: r && n && i,
      roles: [
        M.MASTER,
        M.SUPPORT,
        M.PHARMA_BENEFIT_MANAGER,
        M.RETAIL_PHARMA_BENEFIT_MANAGER
      ],
      label: /* @__PURE__ */ ie(le, { children: [
        /* @__PURE__ */ ie(de, { children: [
          /* @__PURE__ */ T(pe, { className: ve, title: "Produtos", children: /* @__PURE__ */ T(Bn, {}) }),
          "Produtos"
        ] }),
        /* @__PURE__ */ T(
          wt,
          {
            options: [
              {
                roles: [
                  M.MASTER,
                  M.SUPPORT,
                  M.PHARMA_BENEFIT_MANAGER,
                  M.RETAIL_PHARMA_BENEFIT_MANAGER
                ],
                show: !0,
                label: y.map((p, _) => /* @__PURE__ */ T(le, { button: !0, children: /* @__PURE__ */ ie(
                  de,
                  {
                    onClick: () => p.onClick && p.onClick(t),
                    children: [
                      /* @__PURE__ */ T(
                        pe,
                        {
                          className: ve,
                          title: p.label,
                          children: p.icon
                        }
                      ),
                      p.label
                    ]
                  }
                ) }, _))
              }
            ]
          }
        )
      ] })
    },
    {
      show: a && o && i,
      roles: [M.MASTER, M.SUPPORT, M.PHARMA_BENEFIT_MANAGER],
      label: /* @__PURE__ */ ie(le, { children: [
        /* @__PURE__ */ ie(de, { children: [
          /* @__PURE__ */ T(pe, { className: ve, title: "Carregar CPFs", children: /* @__PURE__ */ T(Yt, {}) }),
          "Cpfs"
        ] }),
        /* @__PURE__ */ T(
          wt,
          {
            options: [
              {
                show: !0,
                roles: [
                  M.MASTER,
                  M.SUPPORT,
                  M.PHARMA_BENEFIT_MANAGER
                ],
                label: g.map((p, _) => /* @__PURE__ */ T(le, { button: !0, children: /* @__PURE__ */ ie(
                  de,
                  {
                    onClick: () => p.onClick && p.onClick(t),
                    children: [
                      /* @__PURE__ */ T(
                        pe,
                        {
                          className: ve,
                          title: p.label,
                          children: p.icon
                        }
                      ),
                      p.label
                    ]
                  }
                ) }, _))
              }
            ]
          }
        )
      ] })
    },
    {
      show: s && i,
      roles: [M.MASTER, M.SUPPORT, M.PHARMA_BENEFIT_MANAGER],
      label: /* @__PURE__ */ T(le, { children: /* @__PURE__ */ ie(de, { onClick: () => s(t), children: [
        /* @__PURE__ */ T(pe, { className: ve, title: "Carregar Cnpjs", children: /* @__PURE__ */ T(Yt, {}) }),
        "Cnpjs"
      ] }) })
    },
    {
      roles: [M.MASTER, M.SUPPORT, M.PHARMA_BENEFIT_MANAGER],
      show: u && i,
      label: /* @__PURE__ */ T(le, { children: /* @__PURE__ */ ie(de, { onClick: () => u(t), children: [
        /* @__PURE__ */ T(pe, { className: ve, title: "Editar registro", children: /* @__PURE__ */ T(sr, {}) }),
        "Editar"
      ] }) })
    },
    {
      roles: [
        M.MASTER,
        M.SUPPORT,
        M.PHARMA_BENEFIT_MANAGER,
        M.RETAIL_PHARMA_BENEFIT_MANAGER
      ],
      show: c && f && i,
      label: /* @__PURE__ */ T(
        le,
        {
          alignItems: "center",
          disabled: f(t),
          onClick: () => {
            if (!f(t))
              return c(t);
          },
          children: /* @__PURE__ */ ie(de, { children: [
            /* @__PURE__ */ T(pe, { className: ve, title: "Prioridade", children: /* @__PURE__ */ T(Gn, {}) }),
            "Prioridade"
          ] })
        }
      )
    },
    {
      roles: [M.MASTER, M.SUPPORT, M.PHARMA_BENEFIT_MANAGER],
      show: d && i,
      label: /* @__PURE__ */ T(le, { children: /* @__PURE__ */ ie(
        de,
        {
          onClick: () => d(t).then(
            (p) => p ? h() : null
          ),
          children: [
            /* @__PURE__ */ T(pe, { className: ve, title: "Excluir registro", children: /* @__PURE__ */ T(cr, {}) }),
            "Excluir"
          ]
        }
      ) })
    }
  ];
}, pn = (e) => {
  const r = Buffer.from(e, "base64").toString("utf-8");
  return Number(r.replace("arrayconnection:", ""));
}, ju = ({ pageInfo: e }) => {
  let r = `Exibindo ${e.pageCount} de ${e.totalCount} registros.`;
  try {
    const n = pn(e.startCursor) + 1, t = pn(e.endCursor) + 1;
    !isNaN(n) && n !== t && (r = `Exibindo ${n} a ${t} de ${e.totalCount} registros.`);
  } catch (n) {
    console.error(n);
  }
  return e.pageCount === e.totalCount && (r = `Exibindo ${e.totalCount} registros.`, e.totalCount === 1 && (r = "Exibindo um registro.")), /* @__PURE__ */ T("div", { className: "text-sm text-gray-500", children: r });
};
function ku({
  pageInfo: e,
  goToPreviousPage: r,
  goToNextPage: n
}) {
  return e != null && e.hasNextPage || e != null && e.hasPreviousPage ? /* @__PURE__ */ ie("div", { className: "flex mt-4", children: [
    e != null && e.hasPreviousPage ? /* @__PURE__ */ T(gr, { onClick: () => r(), children: "Página anterior" }) : null,
    e != null && e.hasNextPage ? /* @__PURE__ */ T(gr, { onClick: () => n(), children: "Próxima página" }) : null
  ] }) : null;
}
const Tt = "text-gray-400 dark:hover:text-gray-300 dark:text-gray-400 text-sm";
function Du(e, r) {
  return r === "cursor" ? ((e == null ? void 0 : e.edges) || []).map((n) => n.node) : (e == null ? void 0 : e.data) || [];
}
function Hu({
  hook: e,
  onFilterChange: r,
  columns: n,
  defaultFilters: t,
  editRecord: i,
  deleteRecord: a,
  showRecord: o,
  loadProductGroupRules: s,
  loadCpfs: u,
  cleanCpfs: c,
  loadCnpjs: f,
  paginated: d = !1,
  paginationType: h = "cursor",
  typeMenu: y,
  priorityEnable: g,
  enableButtonPriority: p
}) {
  var re;
  const [_, b] = Xn(
    t || []
  ), { status: I, data: x, error: O, isFetching: v, refetch: U } = e({
    gridFilters: _
  }), te = br(() => {
    var Z;
    h === "cursor" && b([
      ..._.filter((R) => R.id !== "before"),
      { id: "after", value: (Z = x == null ? void 0 : x.pageInfo) == null ? void 0 : Z.endCursor }
    ]);
  }, [x, _, h]), J = br(() => {
    var Z;
    h === "cursor" && b([
      ..._.filter((R) => R.id !== "after"),
      { id: "before", value: (Z = x == null ? void 0 : x.pageInfo) == null ? void 0 : Z.startCursor }
    ]);
  }, [x, _, h]), $ = [ei];
  $.push((Z) => {
    Z.visibleColumns.push((R) => [
      ...R,
      {
        id: "crud",
        Cell: ({ row: ee }) => /* @__PURE__ */ ie("div", { className: "flex gap-x-6", children: [
          y ? /* @__PURE__ */ T(
            wt,
            {
              options: $u({
                editRecord: i,
                deleteRecord: a,
                showRecord: o,
                loadProductGroupRules: s,
                loadCpfs: u,
                cleanCpfs: c,
                loadCnpjs: f,
                typeMenu: y,
                priorityEnable: g,
                enableButtonPriority: p,
                refetch: U,
                row: ee
              })
            }
          ) : null,
          o && !y ? /* @__PURE__ */ T(
            Qe,
            {
              roles: [
                M.MASTER,
                M.SUPPORT,
                M.PHARMA_BENEFIT_MANAGER,
                M.RETAIL_PHARMA_BENEFIT_MANAGER
              ],
              children: /* @__PURE__ */ T(
                Ze,
                {
                  className: Tt,
                  title: "Ver registro",
                  onClick: () => o(ee),
                  children: /* @__PURE__ */ T(Yn, {})
                }
              )
            }
          ) : null,
          i && !y ? /* @__PURE__ */ T(
            Qe,
            {
              roles: [
                M.MASTER,
                M.SUPPORT,
                M.PHARMA_BENEFIT_MANAGER,
                M.RETAIL_PHARMA_BENEFIT_MANAGER
              ],
              children: /* @__PURE__ */ T(
                Ze,
                {
                  className: Tt,
                  title: "Editar registro",
                  onClick: () => i(ee),
                  children: /* @__PURE__ */ T(sr, {})
                }
              )
            }
          ) : null,
          a && !y ? /* @__PURE__ */ T(
            Qe,
            {
              roles: [
                M.MASTER,
                M.SUPPORT,
                M.PHARMA_BENEFIT_MANAGER,
                M.RETAIL_PHARMA_BENEFIT_MANAGER
              ],
              children: /* @__PURE__ */ T(
                Ze,
                {
                  className: Tt,
                  title: "Excluir registro",
                  onClick: () => a(ee).then(
                    (Re) => Re ? U() : null
                  ),
                  children: /* @__PURE__ */ T(cr, {})
                }
              )
            }
          ) : null
        ] })
      }
    ]);
  });
  const X = Qn(
    {
      columns: n,
      data: Du(x, h || "cursor"),
      manualFilters: !0,
      initialState: { filters: _ }
    },
    ...$
  );
  return Zn(() => {
    b(X.state.filters), r && r(X.state.filters);
  }, [X.state, b]), /* @__PURE__ */ ie(Hn, { children: [
    x != null && x.pageInfo && (((re = x == null ? void 0 : x.pageInfo) == null ? void 0 : re.totalCount) || 0) > 0 ? /* @__PURE__ */ T("div", { className: "mb-4", children: /* @__PURE__ */ T(ju, { pageInfo: x.pageInfo }) }) : null,
    /* @__PURE__ */ T(
      ri,
      {
        status: I,
        isFetching: v,
        error: O,
        tableInstance: X
      }
    ),
    d && (x != null && x.pageInfo) ? /* @__PURE__ */ T("div", { className: "mt-4", children: /* @__PURE__ */ T(
      ku,
      {
        pageInfo: x.pageInfo,
        goToNextPage: te,
        goToPreviousPage: J
      }
    ) }) : null
  ] });
}
function Ju({
  column: { options: e, filterValue: r, setFilter: n }
}) {
  return /* @__PURE__ */ ie(
    Kn,
    {
      fontSize: "small",
      value: r,
      onChange: (t) => {
        n(t.target.value || void 0);
      },
      children: [
        /* @__PURE__ */ T(yr, { value: "", children: "Filtrar" }),
        e.map((t) => /* @__PURE__ */ T(yr, { value: t.value, children: t.description || t.value }, t.value))
      ]
    }
  );
}
export {
  Gu as D,
  Hu as G,
  ku as P,
  Ju as S,
  ju as a
};
